// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from "./core/CancelablePromise";
import { OpenAPI } from "./core/OpenAPI";
import { request as __request } from "./core/request";
import type { $OpenApiTs } from "./types.gen";

export class ActionLogService {
    /**
     * Get Action Log
     * Get action log listing.
     * @returns ActionLogResponse Successful Response
     * @throws ApiError
     */
    public static getActionLog(): CancelablePromise<$OpenApiTs["/action_log/"]["get"]["res"][200]> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/action_log/",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Clear Animal Selection Endpoint
     * Clear selection of animals and pups.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static clearAnimalSelection(): CancelablePromise<
        $OpenApiTs["/action_log/clear_animal_selection"]["put"]["res"][200]
    > {
        return __request(OpenAPI, {
            method: "PUT",
            url: "/action_log/clear_animal_selection",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Clear Cage Selection Endpoint
     * Clear selection of cages.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static clearCageSelection(): CancelablePromise<
        $OpenApiTs["/action_log/clear_cage_selection"]["put"]["res"][200]
    > {
        return __request(OpenAPI, {
            method: "PUT",
            url: "/action_log/clear_cage_selection",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Clear Tank Selection Endpoint
     * Clear selection of tanks.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static clearTankSelection(): CancelablePromise<
        $OpenApiTs["/action_log/clear_tank_selection"]["put"]["res"][200]
    > {
        return __request(OpenAPI, {
            method: "PUT",
            url: "/action_log/clear_tank_selection",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Clear Global Selection Endpoint
     * Clear global selection of animals, pups, cages and tanks.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static clearGlobalSelection(): CancelablePromise<
        $OpenApiTs["/action_log/clear_global_selection"]["put"]["res"][200]
    > {
        return __request(OpenAPI, {
            method: "PUT",
            url: "/action_log/clear_global_selection",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class AnimalsService {
    /**
     * Get Animal Detail Data Endpoint
     * Get data for animal detail dialog.
     * @returns AnimalDetailData Successful Response
     * @throws ApiError
     */
    public static getAnimalDetailData(
        data: $OpenApiTs["/animals/{animal_id}/details"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/details"]["get"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/{animal_id}/details",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Animal Pedigree Dialog Data Endpoint
     * Get data for animal pedigree dialog.
     * @returns AnimalPedigreeDialogData Successful Response
     * @throws ApiError
     */
    public static getAnimalPedigreeDialogData(
        data: $OpenApiTs["/animals/{animal_id}/pedigree"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/pedigree"]["get"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/{animal_id}/pedigree",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Animal Cohort Id Endpoint
     * Get the cohort id for an animal.
     * @returns GetAnimalCohortIdResponse Successful Response
     * @throws ApiError
     */
    public static getAnimalCohortId(
        data: $OpenApiTs["/animals/{animal_id}/cohort_id"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/cohort_id"]["get"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/{animal_id}/cohort_id",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Animal Cohort Id Endpoint
     * Set the cohort id for an animal.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setAnimalCohortId(
        data: $OpenApiTs["/animals/{animal_id}/cohort_id"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/cohort_id"]["put"]["res"][200]> {
        const { animalId, cohortId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/cohort_id",
            path: {
                animal_id: animalId,
            },
            query: {
                cohort_id: cohortId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Animal Eartag Endpoint
     * Get eartag for an animal.
     * @returns GetAnimalEartagResponse Successful Response
     * @throws ApiError
     */
    public static getAnimalEartag(
        data: $OpenApiTs["/animals/{animal_id}/eartag"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/eartag"]["get"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/{animal_id}/eartag",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Animal Eartag Endpoint
     * Set eartag for an animal.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setAnimalEartag(
        data: $OpenApiTs["/animals/{animal_id}/eartag"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/eartag"]["put"]["res"][200]> {
        const { animalId, prefix, suffix } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/eartag",
            path: {
                animal_id: animalId,
            },
            query: {
                prefix,
                suffix,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Animal Generation Endpoint
     * Get generation for an animal.
     * @returns GetAnimalGenerationResponse Successful Response
     * @throws ApiError
     */
    public static getAnimalGeneration(
        data: $OpenApiTs["/animals/{animal_id}/generation"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/generation"]["get"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/{animal_id}/generation",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Animal Generation Endpoint
     * Set generation for an animal.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setAnimalGeneration(
        data: $OpenApiTs["/animals/{animal_id}/generation"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/generation"]["put"]["res"][200]> {
        const { animalId, requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/generation",
            path: {
                animal_id: animalId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Animal Genetic Background Endpoint
     * Get genetic background for an animal.
     * @returns GetAnimalGeneticBackgroundResponse Successful Response
     * @throws ApiError
     */
    public static getAnimalGeneticBackground(
        data: $OpenApiTs["/animals/{animal_id}/genetic_background"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/genetic_background"]["get"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/{animal_id}/genetic_background",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Animal Genetic Background Endpoint
     * Set genetic background for an animal.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setAnimalGeneticBackground(
        data: $OpenApiTs["/animals/{animal_id}/genetic_background"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/genetic_background"]["put"]["res"][200]> {
        const { animalId, geneticBackgroundId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/genetic_background",
            path: {
                animal_id: animalId,
            },
            query: {
                genetic_background_id: geneticBackgroundId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Animal Projects Endpoint
     * Get all projects assigned to an animal
     * @returns AnimalProjectOption Successful Response
     * @throws ApiError
     */
    public static getAnimalProjects(
        data: $OpenApiTs["/animals/{animal_id}/projects"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/projects"]["get"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/{animal_id}/projects",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Add Animal Projects Endpoint
     * Assign projects to an animal
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static addAnimalProjects(
        data: $OpenApiTs["/animals/{animal_id}/projects"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/projects"]["post"]["res"][200]> {
        const { animalId, projectIds } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/animals/{animal_id}/projects",
            path: {
                animal_id: animalId,
            },
            query: {
                project_ids: projectIds,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Remove Animal Projects Endpoint
     * Remove projects from an animal
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static removeAnimalProjects(
        data: $OpenApiTs["/animals/{animal_id}/projects"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/projects"]["delete"]["res"][200]> {
        const { animalId, projectIds } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/animals/{animal_id}/projects",
            path: {
                animal_id: animalId,
            },
            query: {
                project_ids: projectIds,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Animal Incompatible Sanitary Status Locations Endpoint
     * Get incompatible sanitary status locations for animals based on given new cage or rack id.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getAnimalIncompatibleSanitaryStatusLocations(
        data: $OpenApiTs["/animals/incompatible_sanitary_status_locations"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/incompatible_sanitary_status_locations"]["get"]["res"][200]> {
        const { animalIds, newCageId, newRackId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/incompatible_sanitary_status_locations",
            query: {
                animal_ids: animalIds,
                new_cage_id: newCageId,
                new_rack_id: newRackId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Animal Lab Id Endpoint
     * Get lab id for an animal.
     * @returns GetAnimalLabIdResponse Successful Response
     * @throws ApiError
     */
    public static getAnimalLabId(
        data: $OpenApiTs["/animals/{animal_id}/lab_id"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/lab_id"]["get"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/{animal_id}/lab_id",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Animal Lab Id Endpoint
     * Set lab id for an animal.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setAnimalLabId(
        data: $OpenApiTs["/animals/{animal_id}/lab_id"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/lab_id"]["put"]["res"][200]> {
        const { animalId, labId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/lab_id",
            path: {
                animal_id: animalId,
            },
            query: {
                lab_id: labId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Animal Rfid Endpoint
     * Get RFID for an animal.
     * @returns GetAnimalRFIDResponse Successful Response
     * @throws ApiError
     */
    public static getAnimalRfId(
        data: $OpenApiTs["/animals/{animal_id}/rfid"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/rfid"]["get"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/{animal_id}/rfid",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Animal Rfid Endpoint
     * Set RFID for an animal.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setAnimalRfId(
        data: $OpenApiTs["/animals/{animal_id}/rfid"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/rfid"]["put"]["res"][200]> {
        const { animalId, rfid } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/rfid",
            path: {
                animal_id: animalId,
            },
            query: {
                rfid,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Animal Medical Condition Dialog Seed Endpoint
     * Get details for the animal SetMedicalConditions-Dialog.
     * @returns AnimalMedicalConditionDialogSeed Successful Response
     * @throws ApiError
     */
    public static getAnimalMedicalConditionDialogSeed(
        data: $OpenApiTs["/animals/{animal_id}/medical_condition_dialog"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/medical_condition_dialog"]["get"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/{animal_id}/medical_condition_dialog",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Animal Medical Conditions Endpoint
     * Set medical conditions for an animal.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setAnimalMedicalConditions(
        data: $OpenApiTs["/animals/{animal_id}/medical_conditions"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/medical_conditions"]["put"]["res"][200]> {
        const { animalId, requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/medical_conditions",
            path: {
                animal_id: animalId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Animal Mutation Dialog Seed Endpoint
     * Get details for the animal SetMutation-Dialog.
     * @returns AnimalMutationDialogSeed Successful Response
     * @throws ApiError
     */
    public static getAnimalMutationDialogSeed(
        data: $OpenApiTs["/animals/{animal_id}/mutation_dialog"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/mutation_dialog"]["get"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/{animal_id}/mutation_dialog",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Animal Mutations Endpoint
     * Set mutations for an animal.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setAnimalMutations(
        data: $OpenApiTs["/animals/{animal_id}/mutations"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/mutations"]["put"]["res"][200]> {
        const { animalId, requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/mutations",
            path: {
                animal_id: animalId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Animal Owner Dialog Seed Endpoint
     * Get details for the animal SetOwner-Dialog.
     * @returns AnimalOwnerDialogSeed Successful Response
     * @throws ApiError
     */
    public static getAnimalOwnerDialogSeed(
        data: $OpenApiTs["/animals/{animal_id}/owner_dialog"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/owner_dialog"]["get"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/{animal_id}/owner_dialog",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Animal Owner Endpoint
     * Set owner for an animal.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setAnimalOwner(
        data: $OpenApiTs["/animals/{animal_id}/owner"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/owner"]["put"]["res"][200]> {
        const { animalId, ownerId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/owner",
            path: {
                animal_id: animalId,
            },
            query: {
                owner_id: ownerId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Animal Responsible Dialog Seed Endpoint
     * Get details for the animal SetResponsible-Dialog.
     * @returns AnimalResponsibleDialogSeed Successful Response
     * @throws ApiError
     */
    public static getAnimalResponsibleDialogSeed(
        data: $OpenApiTs["/animals/{animal_id}/responsible_dialog"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/responsible_dialog"]["get"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/{animal_id}/responsible_dialog",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Animal Responsible Endpoint
     * Set responsible for an animal.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setAnimalResponsible(
        data: $OpenApiTs["/animals/{animal_id}/responsible"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/responsible"]["put"]["res"][200]> {
        const { animalId, responsibleId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/responsible",
            path: {
                animal_id: animalId,
            },
            query: {
                responsible_id: responsibleId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Animal Stud Status Dialog Seed Endpoint
     * Get details for the animal SetStudStatus-Dialog.
     * @returns AnimalStudStatusDialogSeed Successful Response
     * @throws ApiError
     */
    public static getAnimalStudStatusDialogSeed(
        data: $OpenApiTs["/animals/{animal_id}/stud_status_dialog"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/stud_status_dialog"]["get"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/{animal_id}/stud_status_dialog",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Animal Stud Status Endpoint
     * Set stud_status for an animal.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setAnimalStudStatus(
        data: $OpenApiTs["/animals/{animal_id}/stud_status"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/stud_status"]["put"]["res"][200]> {
        const { animalId, studStatusId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/stud_status",
            path: {
                animal_id: animalId,
            },
            query: {
                stud_status_id: studStatusId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Animal Sex Move Sacrifice Dialog Seed Endpoint
     * Get details for the animal SetSexMoveSacrifice-Dialog.
     * @returns AnimalSexMoveSacrificeDialogSeed Successful Response
     * @throws ApiError
     */
    public static getAnimalSexMoveSacrificeDialogSeed(
        data: $OpenApiTs["/animals/{animal_id}/sex_move_sacrifice_dialog"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/sex_move_sacrifice_dialog"]["get"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/{animal_id}/sex_move_sacrifice_dialog",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Add Animal To Request Selection Endpoint
     * Add an animal to request selection.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static addAnimalToRequestSelection(
        data: $OpenApiTs["/animals/{animal_id}/add_to_request_selection"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/add_to_request_selection"]["put"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/add_to_request_selection",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Note Animal In Action Log Endpoint
     * Add note for an animal to action log.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static noteAnimalInActionLog(
        data: $OpenApiTs["/animals/{animal_id}/note_in_action_log"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/note_in_action_log"]["put"]["res"][200]> {
        const { animalId, eartag } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/note_in_action_log",
            path: {
                animal_id: animalId,
            },
            query: {
                eartag,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Resurrect Animal Endpoint
     * Resurrect an animal.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static resurrectAnimal(
        data: $OpenApiTs["/animals/{animal_id}/resurrect"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/resurrect"]["put"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/resurrect",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Sacrifice Animal Endpoint
     * Sacrifice an animal.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static sacrificeAnimal(
        data: $OpenApiTs["/animals/{animal_id}/sacrifice"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/sacrifice"]["put"]["res"][200]> {
        const {
            animalId,
            comment,
            sacrificeReasonId,
            sacrificeMethodId,
            severityLevelId,
            classificationId,
            confirmedLicenseOveruse,
            replaceCurrentLicense,
            sacrificeMotherWithPups,
            keepLicence,
        } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/sacrifice",
            path: {
                animal_id: animalId,
            },
            query: {
                comment,
                sacrifice_reason_id: sacrificeReasonId,
                sacrifice_method_id: sacrificeMethodId,
                severity_level_id: severityLevelId,
                classification_id: classificationId,
                confirmed_license_overuse: confirmedLicenseOveruse,
                replace_current_license: replaceCurrentLicense,
                sacrifice_mother_with_pups: sacrificeMotherWithPups,
                keep_licence: keepLicence,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Animal As Stud Endpoint
     * Set animal as stud.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setAnimalAsStud(
        data: $OpenApiTs["/animals/{animal_id}/set_as_stud"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/set_as_stud"]["put"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/set_as_stud",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Animal Birth Date Endpoint
     * Update birthdate for an animal.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateAnimalBirthDate(
        data: $OpenApiTs["/animals/{animal_id}/birth_date"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/birth_date"]["put"]["res"][200]> {
        const { animalId, birthDate } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/birth_date",
            path: {
                animal_id: animalId,
            },
            query: {
                birth_date: birthDate,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Animal Sacrifice Date Endpoint
     * Update sacrifice date for an animal.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateAnimalSacrificeDate(
        data: $OpenApiTs["/animals/{animal_id}/sacrifice_date"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/sacrifice_date"]["put"]["res"][200]> {
        const { animalId, sacrificeDate } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/sacrifice_date",
            path: {
                animal_id: animalId,
            },
            query: {
                sacrifice_date: sacrificeDate,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Move Animal To Existing Cage Endpoint
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static moveAnimalToExistingCage(
        data: $OpenApiTs["/animals/{animal_id}/move_to_existing_cage"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/move_to_existing_cage"]["put"]["res"][200]> {
        const {
            animalId,
            cageNumber,
            newSex,
            moveMotherWithPups,
            confirmedSanitaryStatus,
            confirmedPlugDateReset,
            confirmedPregnancyReset,
        } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/move_to_existing_cage",
            path: {
                animal_id: animalId,
            },
            query: {
                cage_number: cageNumber,
                new_sex: newSex,
                move_mother_with_pups: moveMotherWithPups,
                confirmed_sanitary_status: confirmedSanitaryStatus,
                confirmed_plug_date_reset: confirmedPlugDateReset,
                confirmed_pregnancy_reset: confirmedPregnancyReset,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Move Animal To New Cage Endpoint
     * Move an animal to a new cage.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static moveAnimalToNewCage(
        data: $OpenApiTs["/animals/{animal_id}/move_to_new_cage"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/move_to_new_cage"]["put"]["res"][200]> {
        const {
            animalId,
            cageType,
            cageCategoryId,
            prefix,
            ownerId,
            rackId,
            cagePosition,
            newSex,
            moveMotherWithPups,
            confirmedSanitaryStatus,
        } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/move_to_new_cage",
            path: {
                animal_id: animalId,
            },
            query: {
                cage_type: cageType,
                cage_category_id: cageCategoryId,
                prefix,
                owner_id: ownerId,
                rack_id: rackId,
                cage_position: cagePosition,
                new_sex: newSex,
                move_mother_with_pups: moveMotherWithPups,
                confirmed_sanitary_status: confirmedSanitaryStatus,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Animal Species Dialog Seed Endpoint
     * Get details for the animal SetSpecies-Dialog.
     * @returns AnimalSpeciesDialogSeed Successful Response
     * @throws ApiError
     */
    public static getAnimalSpeciesDialogSeed(
        data: $OpenApiTs["/animals/{animal_id}/species_dialog"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/species_dialog"]["get"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/{animal_id}/species_dialog",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Animal Species Endpoint
     * Set species for an animal.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setAnimalSpecies(
        data: $OpenApiTs["/animals/{animal_id}/species"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/species"]["put"]["res"][200]> {
        const { animalId, speciesId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/species",
            path: {
                animal_id: animalId,
            },
            query: {
                species_id: speciesId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Animal Strain Dialog Seed Endpoint
     * Get details for the animal SetStrain-Dialog.
     * @returns AnimalStrainDialogSeed Successful Response
     * @throws ApiError
     */
    public static getAnimalStrainDialogSeed(
        data: $OpenApiTs["/animals/{animal_id}/strain_dialog"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/strain_dialog"]["get"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/{animal_id}/strain_dialog",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Animal Strain Endpoint
     * Set strain for animal.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setAnimalStrain(
        data: $OpenApiTs["/animals/{animal_id}/strain"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/strain"]["put"]["res"][200]> {
        const { animalId, strainId, keepMutation, changePupStrain, setSpeciesToStrain } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/animals/{animal_id}/strain",
            path: {
                animal_id: animalId,
            },
            query: {
                strain_id: strainId,
                keep_mutation: keepMutation,
                change_pup_strain: changePupStrain,
                set_species_to_strain: setSpeciesToStrain,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Animal Plug Date Dialog Seed Endpoint
     * Get details for the animal setPlugDate-Dialog.
     * @returns AnimalPlugDateDialogSeed Successful Response
     * @throws ApiError
     */
    public static getAnimalPlugDateDialogSeed(
        data: $OpenApiTs["/animals/{animal_id}/plug_date_dialog_seed"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/plug_date_dialog_seed"]["get"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/{animal_id}/plug_date_dialog_seed",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Animal Plug Date Endpoint
     * Set plug-date for animal.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setAnimalPlugDate(
        data: $OpenApiTs["/animals/{animal_id}/plug_date"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/plug_date"]["post"]["res"][200]> {
        const { animalId, plugDate, fatherId } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/animals/{animal_id}/plug_date",
            path: {
                animal_id: animalId,
            },
            query: {
                plug_date: plugDate,
                father_id: fatherId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Animal Weight Dialog Seed Endpoint
     * Get details for the animal setWeight-Dialog.
     * @returns AnimalWeightDialogSeed Successful Response
     * @throws ApiError
     */
    public static getAnimalWeightDialogSeed(
        data: $OpenApiTs["/animals/{animal_id}/weight_dialog_seed"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/weight_dialog_seed"]["get"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/{animal_id}/weight_dialog_seed",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Animal Weight Endpoint
     * Set weight for animal.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static addAnimalWeight(
        data: $OpenApiTs["/animals/{animal_id}/weight"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/weight"]["post"]["res"][200]> {
        const { animalId, requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/animals/{animal_id}/weight",
            path: {
                animal_id: animalId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Unset Animal Reference Weight Endpoint
     * Unset reference weight for animal.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static unsetAnimalReferenceWeight(
        data: $OpenApiTs["/animals/{animal_id}/reference-weight"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/reference-weight"]["delete"]["res"][200]> {
        const { animalId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/animals/{animal_id}/reference-weight",
            path: {
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete Animal Weight Endpoint
     * Delete weight for animal.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deleteAnimalWeight(
        data: $OpenApiTs["/animals/{animal_id}/weight/{weight_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/{animal_id}/weight/{weight_id}"]["delete"]["res"][200]> {
        const { weightId, animalId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/animals/{animal_id}/weight/{weight_id}",
            path: {
                weight_id: weightId,
                animal_id: animalId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Next Free Eartag
     * Get next unused eartag with the given prefix
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getNextFreeEartag(
        data: $OpenApiTs["/animals/next_free_eartag"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/next_free_eartag"]["get"]["res"][200]> {
        const { eartagPrefix } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/next_free_eartag",
            query: {
                eartag_prefix: eartagPrefix,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Default Wean Suffix
     * Get next unused eartag with the given prefix.
     *
     * Replaces the former "ajax_wean_get_suffix.py" script.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getDefaultWeanSuffix(
        data: $OpenApiTs["/animals/default_wean_suffix"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/default_wean_suffix"]["get"]["res"][200]> {
        const { eartagPrefix } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/default_wean_suffix",
            query: {
                eartag_prefix: eartagPrefix,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Litter Assign Eartag Dialog Seed Endpoint
     * @returns LitterAssignEartagDialogSeed Successful Response
     * @throws ApiError
     */
    public static getLitterAssignEartagDialogSeed(
        data: $OpenApiTs["/animals/get_litter_assign_eartag_dialog_seed"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/get_litter_assign_eartag_dialog_seed"]["get"]["res"][200]> {
        const { birthId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/get_litter_assign_eartag_dialog_seed",
            query: {
                birth_id: birthId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Assign Litter Eartag Endpoint
     * @returns LitterWeanEartagResult Successful Response
     * @throws ApiError
     */
    public static assignLitterEartag(
        data: $OpenApiTs["/animals/assign_litter_eartag"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/assign_litter_eartag"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/animals/assign_litter_eartag",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Litter Wean Dialog Seed Endpoint
     * @returns LitterWeanDialogSeed Successful Response
     * @throws ApiError
     */
    public static getLitterWeanDialogSeed(
        data: $OpenApiTs["/animals/litter_wean_dialog_seed"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/litter_wean_dialog_seed"]["get"]["res"][200]> {
        const { birthId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/animals/litter_wean_dialog_seed",
            query: {
                birth_id: birthId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Wean Litter Endpoint
     * @returns LitterWeanEartagResult Successful Response
     * @throws ApiError
     */
    public static weanLitter(
        data: $OpenApiTs["/animals/wean_litter"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/wean_litter"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/animals/wean_litter",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Quickselect Seed
     * Get seed for animal quickselect.
     * @returns AnimalQuickselectSeed Successful Response
     * @throws ApiError
     */
    public static getAnimalQuickselectSeed(
        data: $OpenApiTs["/animals/quickselect/seed"]["post"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/animals/quickselect/seed"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/animals/quickselect/seed",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Apply Quickselect
     * @returns AnimalQuickselectActionsResponse Successful Response
     * @throws ApiError
     */
    public static applyAnimalQuickselectActions(
        data: $OpenApiTs["/animals/quickselect/apply"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/animals/quickselect/apply"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/animals/quickselect/apply",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class BackgroundTasksService {
    /**
     * Get Status Endpoint
     * Get status of a background task as SSE.
     * @returns BackgroundTaskStatus Successful Response
     * @throws ApiError
     */
    public static getBackgroundTaskStatus(
        data: $OpenApiTs["/background_tasks/{task_id}"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/background_tasks/{task_id}"]["get"]["res"][200]> {
        const { taskId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/background_tasks/{task_id}",
            path: {
                task_id: taskId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class BatchInvoicesService {
    /**
     * Get New Invoice Batch Seed Endpoint
     * Get the seed data to create a new batch of invoices.
     * @returns NewInvoiceBatchSeed Successful Response
     * @throws ApiError
     */
    public static getInvoiceBatchSeed(): CancelablePromise<$OpenApiTs["/batch_invoices/batch/new"]["get"]["res"][200]> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/batch_invoices/batch/new",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Post New Invoice Batch Seed Endpoint
     * Create a new batch of invoices.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static createInvoiceBatch(
        data: $OpenApiTs["/batch_invoices/batch/new"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/batch_invoices/batch/new"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/batch_invoices/batch/new",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Put Invoice Status Endpoint
     * Change the status of an invoice.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setInvoiceStatus(
        data: $OpenApiTs["/batch_invoices/invoice/{invoice_id}/status"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/batch_invoices/invoice/{invoice_id}/status"]["put"]["res"][200]> {
        const { invoiceId, requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/batch_invoices/invoice/{invoice_id}/status",
            path: {
                invoice_id: invoiceId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Put Invoice Batch Status Endpoint
     * Change the status of a whole invoice batch.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setInvoiceBatchStatus(
        data: $OpenApiTs["/batch_invoices/batch/{invoice_batch_id}/status"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/batch_invoices/batch/{invoice_batch_id}/status"]["put"]["res"][200]> {
        const { invoiceBatchId, requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/batch_invoices/batch/{invoice_batch_id}/status",
            path: {
                invoice_batch_id: invoiceBatchId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Put Invoice Discount Endpoint
     * Apply a discount to an invoice.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setInvoiceDiscount(
        data: $OpenApiTs["/batch_invoices/invoice/{invoice_id}/discount"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/batch_invoices/invoice/{invoice_id}/discount"]["put"]["res"][200]> {
        const { invoiceId, requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/batch_invoices/invoice/{invoice_id}/discount",
            path: {
                invoice_id: invoiceId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Reprocess Invoice Batch Endpoint
     * Trigger processing of a batch again.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static reprocessInvoiceBatch(
        data: $OpenApiTs["/batch_invoices/batch/{invoice_batch_id}/reprocess"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/batch_invoices/batch/{invoice_batch_id}/reprocess"]["put"]["res"][200]> {
        const { invoiceBatchId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/batch_invoices/batch/{invoice_batch_id}/reprocess",
            path: {
                invoice_batch_id: invoiceBatchId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class BirthsService {
    /**
     * Close
     * Close birth by setting wean date to the most recent wean date (for partially weaned litter).
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static closeBirth(
        data: $OpenApiTs["/births/{birth_id}/close"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/births/{birth_id}/close"]["put"]["res"][200]> {
        const { birthId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/births/{birth_id}/close",
            path: {
                birth_id: birthId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete
     * Delete birth.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deleteBirth(
        data: $OpenApiTs["/births/{birth_id}/delete"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/births/{birth_id}/delete"]["put"]["res"][200]> {
        const { birthId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/births/{birth_id}/delete",
            path: {
                birth_id: birthId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Litter Birth Date Endpoint
     * Update date for a birth and related animals/pups.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateLitterBirthDate(
        data: $OpenApiTs["/births/{birth_id}/litter_birth_date"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/births/{birth_id}/litter_birth_date"]["put"]["res"][200]> {
        const { birthId, birthDate } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/births/{birth_id}/litter_birth_date",
            path: {
                birth_id: birthId,
            },
            query: {
                birth_date: birthDate,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Pup Quantity
     * Update number of pups for given birth (ID).
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updatePupQuantity(
        data: $OpenApiTs["/births/{birth_id}/pup_quantity"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/births/{birth_id}/pup_quantity"]["put"]["res"][200]> {
        const { birthId, numberOfMales, numberOfFemales, numberOfUnknown, popupType, confirmedLicenseOveruse } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/births/{birth_id}/pup_quantity",
            path: {
                birth_id: birthId,
            },
            query: {
                number_of_males: numberOfMales,
                number_of_females: numberOfFemales,
                number_of_unknown: numberOfUnknown,
                popup_type: popupType,
                confirmed_license_overuse: confirmedLicenseOveruse,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Remove Fetus Flag For Pups
     * Remove fetus flags from pups related to given birth (ID).
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static removeFetusFlagForPups(
        data: $OpenApiTs["/births/{birth_id}/remove_fetus_flag_for_pups"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/births/{birth_id}/remove_fetus_flag_for_pups"]["put"]["res"][200]> {
        const { birthId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/births/{birth_id}/remove_fetus_flag_for_pups",
            path: {
                birth_id: birthId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Comment Endpoint
     * Get comment for given cage (ID).
     * @returns GetCommentResponse Successful Response
     * @throws ApiError
     */
    public static getBirthComment(
        data: $OpenApiTs["/births/{birth_id}/comment"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/births/{birth_id}/comment"]["get"]["res"][200]> {
        const { birthId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/births/{birth_id}/comment",
            path: {
                birth_id: birthId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Comment Endpoint
     * Update comment for given birth (ID).
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateBirthComment(
        data: $OpenApiTs["/births/{birth_id}/comment"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/births/{birth_id}/comment"]["put"]["res"][200]> {
        const { birthId, comment } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/births/{birth_id}/comment",
            path: {
                birth_id: birthId,
            },
            query: {
                comment,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class AnnouncementsService {
    /**
     * Get Announcement
     * Get an announcement by ID.
     *
     * :param announcement_id: The database ID of the announcement.
     * @returns AnnouncementDetails Successful Response
     * @throws ApiError
     */
    public static getAnnouncement(
        data: $OpenApiTs["/announcements/{announcement_id}"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/announcements/{announcement_id}"]["get"]["res"][200]> {
        const { announcementId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/announcements/{announcement_id}",
            path: {
                announcement_id: announcementId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Announcement Endpoint
     * Update an announcement by ID.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateAnnouncement(
        data: $OpenApiTs["/announcements/{announcement_id}"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/announcements/{announcement_id}"]["post"]["res"][200]> {
        const { announcementId, requestBody, resetUserStatus } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/announcements/{announcement_id}",
            path: {
                announcement_id: announcementId,
            },
            query: {
                reset_user_status: resetUserStatus,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete Announcement Enpoint
     * Delete an announcement by ID.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deleteAnnouncement(
        data: $OpenApiTs["/announcements/{announcement_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/announcements/{announcement_id}"]["delete"]["res"][200]> {
        const { announcementId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/announcements/{announcement_id}",
            path: {
                announcement_id: announcementId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Create Announcement Endpoint
     * Create a new announcement.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static createAnnouncement(
        data: $OpenApiTs["/announcements/"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/announcements/"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/announcements/",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class ApiService {
    /**
     * Enable Client Id
     * Enable a api client by id.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static enableClient(
        data: $OpenApiTs["/api/client/{client_id}/enabled"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/api/client/{client_id}/enabled"]["put"]["res"][200]> {
        const { clientId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/api/client/{client_id}/enabled",
            path: {
                client_id: clientId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Disable Client Id
     * Disable a api client by id.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static disableClient(
        data: $OpenApiTs["/api/client/{client_id}/enabled"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/api/client/{client_id}/enabled"]["delete"]["res"][200]> {
        const { clientId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/api/client/{client_id}/enabled",
            path: {
                client_id: clientId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Enable User Id
     * Enable a api user by id.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static enableUser(
        data: $OpenApiTs["/api/user/{user_id}/enabled"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/api/user/{user_id}/enabled"]["put"]["res"][200]> {
        const { userId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/api/user/{user_id}/enabled",
            path: {
                user_id: userId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Disable User Id
     * Disable a api user by id.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static disableUser(
        data: $OpenApiTs["/api/user/{user_id}/enabled"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/api/user/{user_id}/enabled"]["delete"]["res"][200]> {
        const { userId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/api/user/{user_id}/enabled",
            path: {
                user_id: userId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete User Id
     * Delete a api user by id.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deleteUser(
        data: $OpenApiTs["/api/user/{user_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/api/user/{user_id}"]["delete"]["res"][200]> {
        const { userId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/api/user/{user_id}",
            path: {
                user_id: userId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class BuildingMapService {
    /**
     * Get Rack Details Endpoint
     * @returns BuildingMapRack Successful Response
     * @throws ApiError
     */
    public static getBuildingMapRackDetails(
        data: $OpenApiTs["/building_map/rack"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/building_map/rack"]["get"]["res"][200]> {
        const { rackIds } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/building_map/rack",
            query: {
                rack_ids: rackIds,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Move Cage Endpoint
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static moveBuildingMapCage(
        data: $OpenApiTs["/building_map/move_cage"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/building_map/move_cage"]["post"]["res"][200]> {
        const { cageId, targetRackId, targetRackPosition, confirmedSanitaryStatus } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/building_map/move_cage",
            query: {
                cage_id: cageId,
                target_rack_id: targetRackId,
                target_rack_position: targetRackPosition,
                confirmed_sanitary_status: confirmedSanitaryStatus,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Swap Cages Endpoint
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static swapBuildingMapCages(
        data: $OpenApiTs["/building_map/swap_cages"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/building_map/swap_cages"]["post"]["res"][200]> {
        const { firstCageId, secondCageId } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/building_map/swap_cages",
            query: {
                first_cage_id: firstCageId,
                second_cage_id: secondCageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Move Tank Endpoint
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static moveBuildingMapTank(
        data: $OpenApiTs["/building_map/move_tank"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/building_map/move_tank"]["post"]["res"][200]> {
        const { tankId, targetRackId, targetRackPosition } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/building_map/move_tank",
            query: {
                tank_id: tankId,
                target_rack_id: targetRackId,
                target_rack_position: targetRackPosition,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Swap Tanks Endpoint
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static swapBuildingMapTanks(
        data: $OpenApiTs["/building_map/swap_tanks"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/building_map/swap_tanks"]["post"]["res"][200]> {
        const { firstTankId, secondTankId } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/building_map/swap_tanks",
            query: {
                first_tank_id: firstTankId,
                second_tank_id: secondTankId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class CageHardwareService {
    /**
     * Get Cage Hardware Status
     * @returns CageHardwareStatusResponse Successful Response
     * @throws ApiError
     */
    public static getCageHardwareStatus(
        data: $OpenApiTs["/cages/hardware/status"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/hardware/status"]["get"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/cages/hardware/status",
            query: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class GalileiCageTalkerService {
    /**
     * Galilei Post Label
     * Pair a label with a Galilei CageTalker.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static pairLabel(
        data: $OpenApiTs["/cages/hardware/galilei_cage_talker/{cage_id}"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/hardware/galilei_cage_talker/{cage_id}"]["post"]["res"][200]> {
        const { cageId, requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/cages/hardware/galilei_cage_talker/{cage_id}",
            path: {
                cage_id: cageId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Galilei Unpair Label
     * Unpair a label with a Galilei CageTalker.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static unpairLabel(
        data: $OpenApiTs["/cages/hardware/galilei_cage_talker/{cage_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/hardware/galilei_cage_talker/{cage_id}"]["delete"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/cages/hardware/galilei_cage_talker/{cage_id}",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Galilei Update Cage Label
     * Update the label on a Galilei CageTalker.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateLabel(
        data: $OpenApiTs["/cages/hardware/galilei_cage_talker/{cage_id}"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/hardware/galilei_cage_talker/{cage_id}"]["put"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/cages/hardware/galilei_cage_talker/{cage_id}",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Galilei Turn Label Led On
     * Turn the LED on a Galilei CageTalker label on.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static turnLabelLedOn(
        data: $OpenApiTs["/cages/hardware/galilei_cage_talker/{cage_id}/led"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/hardware/galilei_cage_talker/{cage_id}/led"]["post"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/cages/hardware/galilei_cage_talker/{cage_id}/led",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Galilei Turn Label Led Off
     * Turn the LED on a Galilei CageTalker label off.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static turnLabelLedOff(
        data: $OpenApiTs["/cages/hardware/galilei_cage_talker/{cage_id}/led"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/hardware/galilei_cage_talker/{cage_id}/led"]["delete"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/cages/hardware/galilei_cage_talker/{cage_id}/led",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class TecniplastDvcService {
    /**
     * Tecniplast Get Unknown Cages
     * Get a list of unknown (empty) cages from the Tecniplast DVC.
     * @returns TecniplastUnknownCageLocation Successful Response
     * @throws ApiError
     */
    public static getUnknownCages(): CancelablePromise<
        $OpenApiTs["/cages/hardware/tecniplast_dvc/unknown_cages"]["get"]["res"][200]
    > {
        return __request(OpenAPI, {
            method: "GET",
            url: "/cages/hardware/tecniplast_dvc/unknown_cages",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Tecniplast Obtain Dvc Position
     * Obtain a position in the Tecniplast DVC for a cage.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static obtainDvcPosition(
        data: $OpenApiTs["/cages/hardware/tecniplast_dvc/{cage_id}/obtain_dvc_position"]["put"]["req"],
    ): CancelablePromise<
        $OpenApiTs["/cages/hardware/tecniplast_dvc/{cage_id}/obtain_dvc_position"]["put"]["res"][200]
    > {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/cages/hardware/tecniplast_dvc/{cage_id}/obtain_dvc_position",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Tecniplast Update Dvc Cage
     * Update the cage in the Tecniplast DVC.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateDvcCage(
        data: $OpenApiTs["/cages/hardware/tecniplast_dvc/{cage_id}/update_dvc_cage"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/hardware/tecniplast_dvc/{cage_id}/update_dvc_cage"]["put"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/cages/hardware/tecniplast_dvc/{cage_id}/update_dvc_cage",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Tecniplast Connect Dvc Cage
     * Connect a cage to the Tecniplast DVC.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static connectCage(
        data: $OpenApiTs["/cages/hardware/tecniplast_dvc/{cage_id}"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/hardware/tecniplast_dvc/{cage_id}"]["post"]["res"][200]> {
        const { cageId, requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/cages/hardware/tecniplast_dvc/{cage_id}",
            path: {
                cage_id: cageId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Tecniplast Disconnect Dvc Cage
     * Disconnect a cage from the Tecniplast DVC.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static disconnectCage(
        data: $OpenApiTs["/cages/hardware/tecniplast_dvc/{cage_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/hardware/tecniplast_dvc/{cage_id}"]["delete"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/cages/hardware/tecniplast_dvc/{cage_id}",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Tecniplast Turn Cage Led On
     * Turn the LED on for a cage in the Tecniplast DVC.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static turnCageLedOn(
        data: $OpenApiTs["/cages/hardware/tecniplast_dvc/{cage_id}/led"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/hardware/tecniplast_dvc/{cage_id}/led"]["post"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/cages/hardware/tecniplast_dvc/{cage_id}/led",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Tecniplast Turn Cage Led Off
     * Turn the LED off for a cage in the Tecniplast DVC.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static turnCageLedOff(
        data: $OpenApiTs["/cages/hardware/tecniplast_dvc/{cage_id}/led"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/hardware/tecniplast_dvc/{cage_id}/led"]["delete"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/cages/hardware/tecniplast_dvc/{cage_id}/led",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Post Tecniplast Hook
     * Receive a hook call from the Tecniplast DVC.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static postTecniplastDvcHook(
        data: $OpenApiTs["/cages/hardware/tecniplast_dvc/hook"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/hardware/tecniplast_dvc/hook"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/cages/hardware/tecniplast_dvc/hook",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class CagesService {
    /**
     * Get Breeding Cage Detail Data Endpoint
     * Get data for breeding cage detail dialog.
     * @returns BreedingCageDetailData Successful Response
     * @throws ApiError
     */
    public static getBreedingCageDetailData(
        data: $OpenApiTs["/cages/{cage_id}/breeding_cage_details"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/breeding_cage_details"]["get"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/cages/{cage_id}/breeding_cage_details",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Stock Cage Detail Data Endpoint
     * Get data for stock cage detail dialog.
     * @returns StockCageDetailData Successful Response
     * @throws ApiError
     */
    public static getStockCageDetailData(
        data: $OpenApiTs["/cages/{cage_id}/stock_cage_details"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/stock_cage_details"]["get"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/cages/{cage_id}/stock_cage_details",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Next Free Cagenumber Suffix
     * Get next unused cagenumber suffix with the given prefix.
     * @returns NextCagenumberSuffix Successful Response
     * @throws ApiError
     */
    public static getNextFreeCagenumberSuffix(
        data: $OpenApiTs["/cages/next_free_cagenumber_suffix"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/next_free_cagenumber_suffix"]["get"]["res"][200]> {
        const { prefix } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/cages/next_free_cagenumber_suffix",
            query: {
                prefix,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Quickselect Seed
     * Get seed for cage quickselect.
     * @returns CageQuickselectSeed Successful Response
     * @throws ApiError
     */
    public static getCageQuickselectSeed(
        data: $OpenApiTs["/cages/quickselect/seed"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/quickselect/seed"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/cages/quickselect/seed",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Apply Quickselect
     * Apply Quickselect actions for selected cage IDs.
     * @returns CageQuickselectActionsResponse Successful Response
     * @throws ApiError
     */
    public static applyCageQuickselectActions(
        data: $OpenApiTs["/cages/quickselect/apply"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/quickselect/apply"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/cages/quickselect/apply",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Add Cage To Request Selection Endpoint
     * Add a cage to request selection.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static addCageToRequestSelection(
        data: $OpenApiTs["/cages/{cage_id}/add_to_request_selection"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/add_to_request_selection"]["put"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/cages/{cage_id}/add_to_request_selection",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Close Cage Endpoint
     * Close a cage.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static closeCage(
        data: $OpenApiTs["/cages/{cage_id}/close"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/close"]["put"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/cages/{cage_id}/close",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Note Cage In Action Log Endpoint
     * Add note for a cage to action log.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static noteCageInActionLog(
        data: $OpenApiTs["/cages/{cage_id}/note_in_action_log"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/note_in_action_log"]["put"]["res"][200]> {
        const { cageId, cageNumber } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/cages/{cage_id}/note_in_action_log",
            path: {
                cage_id: cageId,
            },
            query: {
                cage_number: cageNumber,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Reopen Cage Endpoint
     * Reopen a cage.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static reopenCage(
        data: $OpenApiTs["/cages/{cage_id}/resurrect"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/resurrect"]["put"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/cages/{cage_id}/resurrect",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Category Endpoint
     * Get category for a cage.
     * @returns GetCageCategoryResponse Successful Response
     * @throws ApiError
     */
    public static getCageCategory(
        data: $OpenApiTs["/cages/{cage_id}/category"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/category"]["get"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/cages/{cage_id}/category",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Category Endpoint
     * Set category for a cage.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setCageCategory(
        data: $OpenApiTs["/cages/{cage_id}/category"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/category"]["put"]["res"][200]> {
        const { cageId, categoryId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/cages/{cage_id}/category",
            path: {
                cage_id: cageId,
            },
            query: {
                category_id: categoryId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Date In Endpoint
     * Update date in for an animal in cage.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateDateIn(
        data: $OpenApiTs["/cages/{cage_id}/date_in"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/date_in"]["put"]["res"][200]> {
        const { cageId, animalId, dateIn } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/cages/{cage_id}/date_in",
            path: {
                cage_id: cageId,
            },
            query: {
                animal_id: animalId,
                date_in: dateIn,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Date Out Endpoint
     * Update date out for an animal in cage.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateDateOut(
        data: $OpenApiTs["/cages/{cage_id}/date_out"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/date_out"]["put"]["res"][200]> {
        const { cageId, animalId, dateOut } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/cages/{cage_id}/date_out",
            path: {
                cage_id: cageId,
            },
            query: {
                animal_id: animalId,
                date_out: dateOut,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Incompatible Sanitary Status Locations Endpoint
     * Get incompatible sanitary status locations for cages based on given new cage or rack id.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getIncompatibleSanitaryStatusLocations(
        data: $OpenApiTs["/cages/incompatible_sanitary_status_locations"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/incompatible_sanitary_status_locations"]["get"]["res"][200]> {
        const { cageIds, newCageId, newRackId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/cages/incompatible_sanitary_status_locations",
            query: {
                cage_ids: cageIds,
                new_cage_id: newCageId,
                new_rack_id: newRackId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Label Endpoint
     * Get label for a cage.
     * @returns GetCageLabelResponse Successful Response
     * @throws ApiError
     */
    public static getCageLabel(
        data: $OpenApiTs["/cages/{cage_id}/label"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/label"]["get"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/cages/{cage_id}/label",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Label Endpoint
     * Set category for a cage.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setCageLabel(
        data: $OpenApiTs["/cages/{cage_id}/label"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/label"]["put"]["res"][200]> {
        const { cageId, label } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/cages/{cage_id}/label",
            path: {
                cage_id: cageId,
            },
            query: {
                label,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Layout Endpoint
     * Get layout for a cage.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getCageLayout(
        data: $OpenApiTs["/cages/{cage_id}/layout"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/layout"]["get"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/cages/{cage_id}/layout",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Location Endpoint
     * Get location for a cage.
     * @returns GetCageLocationResponse Successful Response
     * @throws ApiError
     */
    public static getCageLocation(
        data: $OpenApiTs["/cages/{cage_id}/location"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/location"]["get"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/cages/{cage_id}/location",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Location Endpoint
     * Set category for a cage.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setCageLocation(
        data: $OpenApiTs["/cages/{cage_id}/location"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/location"]["put"]["res"][200]> {
        const { cageId, rackId, cagePosition, confirmedSanitaryStatus } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/cages/{cage_id}/location",
            path: {
                cage_id: cageId,
            },
            query: {
                rack_id: rackId,
                cage_position: cagePosition,
                confirmed_sanitary_status: confirmedSanitaryStatus,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Number Endpoint
     * Get number for a cage.
     * @returns GetCageNumberResponse Successful Response
     * @throws ApiError
     */
    public static getCageNumber(
        data: $OpenApiTs["/cages/{cage_id}/number"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/number"]["get"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/cages/{cage_id}/number",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Number Endpoint
     * Set number for a cage.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setCageNumber(
        data: $OpenApiTs["/cages/{cage_id}/number"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/number"]["put"]["res"][200]> {
        const { cageId, prefix, suffix } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/cages/{cage_id}/number",
            path: {
                cage_id: cageId,
            },
            query: {
                prefix,
                suffix,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Owner Endpoint
     * Get owner for a cage.
     * @returns GetCageOwnerResponse Successful Response
     * @throws ApiError
     */
    public static getCageOwner(
        data: $OpenApiTs["/cages/{cage_id}/owner"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/owner"]["get"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/cages/{cage_id}/owner",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Owner Endpoint
     * Set owner for a cage.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setCageOwner(
        data: $OpenApiTs["/cages/{cage_id}/owner"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/owner"]["put"]["res"][200]> {
        const { cageId, ownerId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/cages/{cage_id}/owner",
            path: {
                cage_id: cageId,
            },
            query: {
                owner_id: ownerId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Position Endpoint
     * Get position for a cage.
     * @returns GetCagePositionResponse Successful Response
     * @throws ApiError
     */
    public static getCagePosition(
        data: $OpenApiTs["/cages/{cage_id}/position"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/position"]["get"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/cages/{cage_id}/position",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Position Endpoint
     * Set position for a cage.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setCagePosition(
        data: $OpenApiTs["/cages/{cage_id}/position"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/position"]["put"]["res"][200]> {
        const { cageId, position } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/cages/{cage_id}/position",
            path: {
                cage_id: cageId,
            },
            query: {
                position,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Responsible Endpoint
     * Get responsible for a cage.
     * @returns GetCageResponsibleResponse Successful Response
     * @throws ApiError
     */
    public static getCageResponsible(
        data: $OpenApiTs["/cages/{cage_id}/responsible"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/responsible"]["get"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/cages/{cage_id}/responsible",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Responsible Endpoint
     * Set responsible for a cage.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setCageResponsible(
        data: $OpenApiTs["/cages/{cage_id}/responsible"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/responsible"]["put"]["res"][200]> {
        const { cageId, responsibleId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/cages/{cage_id}/responsible",
            path: {
                cage_id: cageId,
            },
            query: {
                responsible_id: responsibleId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Cage Projects Endpoint
     * Get all projects assigned to a cage
     * @returns CageProjectOption Successful Response
     * @throws ApiError
     */
    public static getCageProjects(
        data: $OpenApiTs["/cages/{cage_id}/projects"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/projects"]["get"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/cages/{cage_id}/projects",
            path: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Add Cage Projects Endpoint
     * Assign projects to a cage
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static addCageProjects(
        data: $OpenApiTs["/cages/{cage_id}/projects"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/projects"]["post"]["res"][200]> {
        const { cageId, projectIds } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/cages/{cage_id}/projects",
            path: {
                cage_id: cageId,
            },
            query: {
                project_ids: projectIds,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Remove Cage Projects Endpoint
     * Remove projects from a cage
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static removeCageProjects(
        data: $OpenApiTs["/cages/{cage_id}/projects"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/cages/{cage_id}/projects"]["delete"]["res"][200]> {
        const { cageId, projectIds } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/cages/{cage_id}/projects",
            path: {
                cage_id: cageId,
            },
            query: {
                project_ids: projectIds,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class CommentsService {
    /**
     * Mark Comment Visible
     * Mark a comment as visible.
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static markCommentVisible(
        data: $OpenApiTs["/comments/{comment_id}/visible"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/comments/{comment_id}/visible"]["put"]["res"][200]> {
        const { commentId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/comments/{comment_id}/visible",
            path: {
                comment_id: commentId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Mark Comment Hidden
     * Mark a comment as hidden.
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static markCommentHidden(
        data: $OpenApiTs["/comments/{comment_id}/visible"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/comments/{comment_id}/visible"]["delete"]["res"][200]> {
        const { commentId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/comments/{comment_id}/visible",
            path: {
                comment_id: commentId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Comment Widget Seed
     * Get a seed for the comment widget.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getCommentWidgetSeed(
        data: $OpenApiTs["/comments/seed"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/comments/seed"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/comments/seed",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Post Comment
     * Post a comment.
     *
     * Return the comment ID and a new seed for the comment widget.
     * @returns PostCommentResponse Successful Response
     * @throws ApiError
     */
    public static postComment(
        data: $OpenApiTs["/comments/"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/comments/"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/comments/",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Attributes
     * Update the comment attribute list.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateCommentAttributeList(
        data: $OpenApiTs["/comments/attributes"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/comments/attributes"]["put"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/comments/attributes",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class CryotanksService {
    /**
     * Get Cryotanks For Setting
     * Get cryotanks to specify where to place cryopreserved content.
     * @returns IdNameProperty Successful Response
     * @throws ApiError
     */
    public static getCryotanksForSetting(): CancelablePromise<$OpenApiTs["/cryotanks/for_setting"]["get"]["res"][200]> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/cryotanks/for_setting",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Cryotank Details
     * Get cryotank details.
     * @returns CryotankDetails Successful Response
     * @throws ApiError
     */
    public static getCryotankDetails(
        data: $OpenApiTs["/cryotanks/{cryotank_id}/details"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/cryotanks/{cryotank_id}/details"]["get"]["res"][200]> {
        const { cryotankId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/cryotanks/{cryotank_id}/details",
            path: {
                cryotank_id: cryotankId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Container Details
     * Get data of a container inside a cryotank to display in the cryotank browser.
     * @returns CryotankPathData Successful Response
     * @throws ApiError
     */
    public static getContainerDetails(
        data: $OpenApiTs["/cryotanks/{cryotank_id}/container_details"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/cryotanks/{cryotank_id}/container_details"]["get"]["res"][200]> {
        const { cryotankId, labelPath } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/cryotanks/{cryotank_id}/container_details",
            path: {
                cryotank_id: cryotankId,
            },
            query: {
                label_path: labelPath,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Straw Details
     * Get content data of a straw inside a cryotank.
     * @returns CryotankCellContent Successful Response
     * @throws ApiError
     */
    public static getStrawDetails(
        data: $OpenApiTs["/cryotanks/{cryotank_id}/straw_details"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/cryotanks/{cryotank_id}/straw_details"]["get"]["res"][200]> {
        const { cryotankId, labelPath } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/cryotanks/{cryotank_id}/straw_details",
            path: {
                cryotank_id: cryotankId,
            },
            query: {
                label_path: labelPath,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Straw Label
     * Get straw label of a known cryotank content (a frozen embryo group or sperm volume)
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getStrawLabel(
        data: $OpenApiTs["/cryotanks/cryotank_content/{cryotank_content_id}/straw_label"]["get"]["req"],
    ): CancelablePromise<
        $OpenApiTs["/cryotanks/cryotank_content/{cryotank_content_id}/straw_label"]["get"]["res"][200]
    > {
        const { cryotankContentId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/cryotanks/cryotank_content/{cryotank_content_id}/straw_label",
            path: {
                cryotank_content_id: cryotankContentId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Straw Label
     * Set straw label of a known cryotank content (a frozen embryo group or sperm volume)
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setStrawLabel(
        data: $OpenApiTs["/cryotanks/cryotank_content/{cryotank_content_id}"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/cryotanks/cryotank_content/{cryotank_content_id}"]["put"]["res"][200]> {
        const { cryotankContentId, strawLabel } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/cryotanks/cryotank_content/{cryotank_content_id}",
            path: {
                cryotank_content_id: cryotankContentId,
            },
            query: {
                straw_label: strawLabel,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Display Hints For Setting
     * Get possible display hint that control the rendering of the cryotank nodes.
     * @returns DisplayHintProperties Successful Response
     * @throws ApiError
     */
    public static getCryotankNodeDisplayHintsForSetting(): CancelablePromise<
        $OpenApiTs["/cryotanks/display_hints/for_setting"]["get"]["res"][200]
    > {
        return __request(OpenAPI, {
            method: "GET",
            url: "/cryotanks/display_hints/for_setting",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Create Cryotank
     * Create new cryotank.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static createCryotank(
        data: $OpenApiTs["/cryotanks"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/cryotanks"]["post"]["res"][200]> {
        const { name, active, requestBody, description } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/cryotanks",
            query: {
                name,
                active,
                description,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Cryotank
     * Update data of existing cryotank.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateCryotank(
        data: $OpenApiTs["/cryotanks/{cryotank_id}"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/cryotanks/{cryotank_id}"]["put"]["res"][200]> {
        const { cryotankId, name, active, requestBody, description } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/cryotanks/{cryotank_id}",
            path: {
                cryotank_id: cryotankId,
            },
            query: {
                name,
                active,
                description,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete Cryotank
     * Delete a cryotank.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deleteCryotank(
        data: $OpenApiTs["/cryotanks/{cryotank_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/cryotanks/{cryotank_id}"]["delete"]["res"][200]> {
        const { cryotankId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/cryotanks/{cryotank_id}",
            path: {
                cryotank_id: cryotankId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Cryotank Path Color
     * Update the color of one node inside the cryotank.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateCryotankPathColor(
        data: $OpenApiTs["/cryotanks/{cryotank_id}/path_color"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/cryotanks/{cryotank_id}/path_color"]["put"]["res"][200]> {
        const { cryotankId, requestBody, color } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/cryotanks/{cryotank_id}/path_color",
            path: {
                cryotank_id: cryotankId,
            },
            query: {
                color,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class DevicesService {
    /**
     * Update Device Categories Endpoint
     * Update the device categories.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateDeviceCategories(
        data: $OpenApiTs["/devices/device_categories"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/devices/device_categories"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/devices/device_categories",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Device Event Categories Endpoint
     * Update the device categories.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateDeviceEventCategories(
        data: $OpenApiTs["/devices/device_event_categories"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/devices/device_event_categories"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/devices/device_event_categories",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get New Device Endpoint
     * Get a device.
     * @returns NewDeviceDialogSeed Successful Response
     * @throws ApiError
     */
    public static getNewDeviceDialogSeed(): CancelablePromise<$OpenApiTs["/devices/device/new"]["get"]["res"][200]> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/devices/device/new",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Existing Device Endpoint
     * Get a device.
     * @returns ExistingDeviceDialogSeed Successful Response
     * @throws ApiError
     */
    public static getExistingDeviceDialogSeed(
        data: $OpenApiTs["/devices/device/{device_id}"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/devices/device/{device_id}"]["get"]["res"][200]> {
        const { deviceId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/devices/device/{device_id}",
            path: {
                device_id: deviceId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Device Endpoint
     * Update a device.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateDevice(
        data: $OpenApiTs["/devices/device/{device_id}"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/devices/device/{device_id}"]["put"]["res"][200]> {
        const { deviceId, requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/devices/device/{device_id}",
            path: {
                device_id: deviceId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Add Device Endpoint
     * Add a device.
     * @returns number Successful Response
     * @throws ApiError
     */
    public static addDevice(
        data: $OpenApiTs["/devices/device/"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/devices/device/"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/devices/device/",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get New Device Event Endpoint
     * Get a new device event dialog seed.
     * @returns NewDeviceEventDialogSeed Successful Response
     * @throws ApiError
     */
    public static getNewDeviceEventDialogSeed(
        data: $OpenApiTs["/devices/device/{device_id}/events/new"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/devices/device/{device_id}/events/new"]["get"]["res"][200]> {
        const { deviceId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/devices/device/{device_id}/events/new",
            path: {
                device_id: deviceId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Existing Device Event Endpoint
     * Get an existing device event dialog seed.
     * @returns ExistingDeviceEventDialogSeed Successful Response
     * @throws ApiError
     */
    public static getExistingDeviceEventDialogSeed(
        data: $OpenApiTs["/devices/device/{device_id}/events/{event_id}"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/devices/device/{device_id}/events/{event_id}"]["get"]["res"][200]> {
        const { deviceId, eventId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/devices/device/{device_id}/events/{event_id}",
            path: {
                device_id: deviceId,
                event_id: eventId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Device Event Endpoint
     * Update a device event.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateDeviceEvent(
        data: $OpenApiTs["/devices/device/{device_id}/events/{event_id}"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/devices/device/{device_id}/events/{event_id}"]["put"]["res"][200]> {
        const { deviceId, eventId, requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/devices/device/{device_id}/events/{event_id}",
            path: {
                device_id: deviceId,
                event_id: eventId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Add Device Event Endpoint
     * Add a device event.
     * @returns number Successful Response
     * @throws ApiError
     */
    public static addDeviceEvent(
        data: $OpenApiTs["/devices/device/{device_id}/events"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/devices/device/{device_id}/events"]["post"]["res"][200]> {
        const { deviceId, requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/devices/device/{device_id}/events",
            path: {
                device_id: deviceId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class DocumentsService {
    /**
     * Get Document Widget Seed
     * Get a seed for the document widget.
     * @returns DocumentWidgetSeed Successful Response
     * @throws ApiError
     */
    public static getDocumentWidgetSeed(
        data: $OpenApiTs["/documents/seed"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/documents/seed"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/documents/seed",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Post Document
     * Upload a document.
     *
     * Return the ID of the document.
     * @returns number Successful Response
     * @throws ApiError
     */
    public static storeDocument(
        data: $OpenApiTs["/documents/"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/documents/"]["post"]["res"][200]> {
        const { formData } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/documents/",
            formData,
            mediaType: "multipart/form-data",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete Document Subjects
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static removeDocumentSubjects(
        data: $OpenApiTs["/documents/{document_id}/subjects"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/documents/{document_id}/subjects"]["delete"]["res"][200]> {
        const { documentId, requestBody } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/documents/{document_id}/subjects",
            path: {
                document_id: documentId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete Document Id
     * Delete a document.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deleteDocument(
        data: $OpenApiTs["/documents/{document_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/documents/{document_id}"]["delete"]["res"][200]> {
        const { documentId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/documents/{document_id}",
            path: {
                document_id: documentId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Independent Document Id
     * Get details of an independent document.
     * @returns IndependentDocumentDetails Successful Response
     * @throws ApiError
     */
    public static getIndependentDocumentDetails(
        data: $OpenApiTs["/documents/independent/{document_id}"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/documents/independent/{document_id}"]["get"]["res"][200]> {
        const { documentId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/documents/independent/{document_id}",
            path: {
                document_id: documentId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Independent Document Id
     * Update an independent document.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateIndependentDocument(
        data: $OpenApiTs["/documents/independent/{document_id}"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/documents/independent/{document_id}"]["put"]["res"][200]> {
        const { documentId, requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/documents/independent/{document_id}",
            path: {
                document_id: documentId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Add Independent Document
     * Add an independent document.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static addIndependentDocument(
        data: $OpenApiTs["/documents/independent"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/documents/independent"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/documents/independent",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class DrugRequestsService {
    /**
     * Get Drug Request Details Endpoint
     * Get dialog seed for drug request details
     * @returns DrugRequestDetailSeed Successful Response
     * @throws ApiError
     */
    public static getDrugRequestDetails(
        data: $OpenApiTs["/drug_requests/details"]["get"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/drug_requests/details"]["get"]["res"][200]> {
        const { drugRequestId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/drug_requests/details",
            query: {
                drug_request_id: drugRequestId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Create Drug Request Endpoint
     * Create a new drug request.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static createDrugRequest(
        data: $OpenApiTs["/drug_requests/"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/drug_requests/"]["post"]["res"][200]> {
        const { drugId, supplierDrugRegisterId, recipientDrugRegisterId, quantity, unit, licenseId, projectId } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/drug_requests/",
            query: {
                drug_id: drugId,
                supplier_drug_register_id: supplierDrugRegisterId,
                recipient_drug_register_id: recipientDrugRegisterId,
                quantity,
                unit,
                license_id: licenseId,
                project_id: projectId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Drug Request Endpoint
     * Update a drug request by ID.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateDrugRequest(
        data: $OpenApiTs["/drug_requests/{drug_request_id}"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/drug_requests/{drug_request_id}"]["put"]["res"][200]> {
        const {
            drugRequestId,
            drugId,
            supplierDrugRegisterId,
            recipientDrugRegisterId,
            quantity,
            unit,
            licenseId,
            projectId,
        } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/drug_requests/{drug_request_id}",
            path: {
                drug_request_id: drugRequestId,
            },
            query: {
                drug_id: drugId,
                supplier_drug_register_id: supplierDrugRegisterId,
                recipient_drug_register_id: recipientDrugRegisterId,
                quantity,
                unit,
                license_id: licenseId,
                project_id: projectId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Drug Request Status Endpoint
     * Set the status for a drug request.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setDrugRequestStatus(
        data: $OpenApiTs["/drug_requests/{drug_request_id}/status"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/drug_requests/{drug_request_id}/status"]["put"]["res"][200]> {
        const { drugRequestId, newStatus } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/drug_requests/{drug_request_id}/status",
            path: {
                drug_request_id: drugRequestId,
            },
            query: {
                new_status: newStatus,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class DrugsService {
    /**
     * Get Drug Details Endpoint
     * Get dialog seed for drug details
     * @returns DrugDetailSeed Successful Response
     * @throws ApiError
     */
    public static getDrugDetails(
        data: $OpenApiTs["/drugs/details"]["get"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/drugs/details"]["get"]["res"][200]> {
        const { drugId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/drugs/details",
            query: {
                drug_id: drugId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Create Drug Endpoint
     * Create a new drug.
     * @returns CreateDrugResponse Successful Response
     * @throws ApiError
     */
    public static createDrug(
        data: $OpenApiTs["/drugs/"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/drugs/"]["post"]["res"][200]> {
        const {
            name,
            drugCategoryId,
            activeIngredient,
            administrationRoute,
            contraindication,
            dosing,
            excipient,
            indication,
            instructions,
            manufacturer,
            outdateDays,
            pharmaceuticalForm,
            status,
            storageConditions,
            requestBody,
        } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/drugs/",
            query: {
                name,
                drug_category_id: drugCategoryId,
                active_ingredient: activeIngredient,
                administration_route: administrationRoute,
                contraindication,
                dosing,
                excipient,
                indication,
                instructions,
                manufacturer,
                outdate_days: outdateDays,
                pharmaceutical_form: pharmaceuticalForm,
                status,
                storage_conditions: storageConditions,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Drug Endpoint
     * Update a drug by ID.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateDrug(
        data: $OpenApiTs["/drugs/{drug_id}"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/drugs/{drug_id}"]["put"]["res"][200]> {
        const {
            drugId,
            name,
            drugCategoryId,
            activeIngredient,
            administrationRoute,
            contraindication,
            dosing,
            excipient,
            indication,
            instructions,
            manufacturer,
            outdateDays,
            pharmaceuticalForm,
            status,
            storageConditions,
            requestBody,
        } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/drugs/{drug_id}",
            path: {
                drug_id: drugId,
            },
            query: {
                name,
                drug_category_id: drugCategoryId,
                active_ingredient: activeIngredient,
                administration_route: administrationRoute,
                contraindication,
                dosing,
                excipient,
                indication,
                instructions,
                manufacturer,
                outdate_days: outdateDays,
                pharmaceutical_form: pharmaceuticalForm,
                status,
                storage_conditions: storageConditions,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete Drug Endpoint
     * Delete a drug by ID.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deleteDrug(
        data: $OpenApiTs["/drugs/{drug_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/drugs/{drug_id}"]["delete"]["res"][200]> {
        const { drugId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/drugs/{drug_id}",
            path: {
                drug_id: drugId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Drugs For Procedure For Setting Endpoint
     * Get the list of available drugs for applying a procedure.
     * @returns IdNameProperty Successful Response
     * @throws ApiError
     */
    public static getDrugsForProcedureForSetting(
        data: $OpenApiTs["/drugs/drugs_for_procedure/{procedure_id}/for_setting"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/drugs/drugs_for_procedure/{procedure_id}/for_setting"]["get"]["res"][200]> {
        const { procedureId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/drugs/drugs_for_procedure/{procedure_id}/for_setting",
            path: {
                procedure_id: procedureId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Drug Categories
     * Update the drug categories.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateDrugCategories(
        data: $OpenApiTs["/drugs/categories"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/drugs/categories"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/drugs/categories",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Drug Package Details Endpoint
     * Get dialog seed for drug package details
     * @returns DrugPackageDetailSeed Successful Response
     * @throws ApiError
     */
    public static getDrugPackageDetails(
        data: $OpenApiTs["/drugs/packages"]["get"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/drugs/packages"]["get"]["res"][200]> {
        const { drugPackageId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/drugs/packages",
            query: {
                drug_package_id: drugPackageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Create Drug Packages Endpoint
     * Create multiple drug packages with the same data.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static createDrugPackages(
        data: $OpenApiTs["/drugs/packages"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/drugs/packages"]["post"]["res"][200]> {
        const {
            numberOfPackages,
            drugId,
            drugRegisterId,
            expiryDate,
            quantity,
            unit,
            lotNumber,
            openDate,
            packageLabel,
            packageType,
        } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/drugs/packages",
            query: {
                number_of_packages: numberOfPackages,
                drug_id: drugId,
                drug_register_id: drugRegisterId,
                expiry_date: expiryDate,
                quantity,
                unit,
                lot_number: lotNumber,
                open_date: openDate,
                package_label: packageLabel,
                package_type: packageType,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Drug Package Endpoint
     * Update a drug package by ID.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateDrugPackage(
        data: $OpenApiTs["/drugs/packages/{drug_package_id}"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/drugs/packages/{drug_package_id}"]["put"]["res"][200]> {
        const {
            drugPackageId,
            drugId,
            expiryDate,
            quantity,
            unit,
            packageNumber,
            lotNumber,
            openDate,
            packageLabel,
            packageType,
        } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/drugs/packages/{drug_package_id}",
            path: {
                drug_package_id: drugPackageId,
            },
            query: {
                drug_id: drugId,
                expiry_date: expiryDate,
                quantity,
                unit,
                package_number: packageNumber,
                lot_number: lotNumber,
                open_date: openDate,
                package_label: packageLabel,
                package_type: packageType,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete Drug Package Endpoint
     * Delete a drug package by ID.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deleteDrugPackage(
        data: $OpenApiTs["/drugs/packages/{drug_package_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/drugs/packages/{drug_package_id}"]["delete"]["res"][200]> {
        const { drugPackageId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/drugs/packages/{drug_package_id}",
            path: {
                drug_package_id: drugPackageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Drug Package Status Endpoint
     * Set status for a drug package.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setDrugPackageStatus(
        data: $OpenApiTs["/drugs/packages/{drug_package_id}/status"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/drugs/packages/{drug_package_id}/status"]["put"]["res"][200]> {
        const { drugPackageId, status } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/drugs/packages/{drug_package_id}/status",
            path: {
                drug_package_id: drugPackageId,
            },
            query: {
                status,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Sign Off Drug Package Endpoint
     * Sign off elimination of a drug package by ID.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static signOffDrugPackage(
        data: $OpenApiTs["/drugs/packages/{drug_package_id}/sign_off"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/drugs/packages/{drug_package_id}/sign_off"]["put"]["res"][200]> {
        const { drugPackageId, nextSignOffUserId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/drugs/packages/{drug_package_id}/sign_off",
            path: {
                drug_package_id: drugPackageId,
            },
            query: {
                next_sign_off_user_id: nextSignOffUserId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Quickselect Seed
     * Get seed for drug package quickselect.
     * @returns DrugPackageQuickselectSeed Successful Response
     * @throws ApiError
     */
    public static getDrugPackageQuickselectSeed(
        data: $OpenApiTs["/drugs/quickselect/seed"]["post"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/drugs/quickselect/seed"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/drugs/quickselect/seed",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Apply Quickselect
     * @returns DrugPackageQuickselectActionsResponse Successful Response
     * @throws ApiError
     */
    public static applyDrugPackageQuickselectActions(
        data: $OpenApiTs["/drugs/quickselect/apply"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/drugs/quickselect/apply"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/drugs/quickselect/apply",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Drug Packages For Setting Endpoint
     * Get the list of available drug packages for the given drug id.
     * @returns DrugPackageOption Successful Response
     * @throws ApiError
     */
    public static getDrugPackagesForSetting(
        data: $OpenApiTs["/drugs/drug_packages/for_setting"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/drugs/drug_packages/for_setting"]["get"]["res"][200]> {
        const { drugId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/drugs/drug_packages/for_setting",
            query: {
                drug_id: drugId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Drug Register Details Endpoint
     * Get dialog seed for drug register details
     * @returns DrugRegisterDetailSeed Successful Response
     * @throws ApiError
     */
    public static getDrugRegisterDetails(
        data: $OpenApiTs["/drugs/registers"]["get"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/drugs/registers"]["get"]["res"][200]> {
        const { drugRegisterId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/drugs/registers",
            query: {
                drug_register_id: drugRegisterId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Create Drug Register Endpoint
     * Create a new drug register.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static createDrugRegister(
        data: $OpenApiTs["/drugs/registers"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/drugs/registers"]["post"]["res"][200]> {
        const { name, roomId, allowOrder, status, requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/drugs/registers",
            query: {
                name,
                room_id: roomId,
                allow_order: allowOrder,
                status,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Drug Register Endpoint
     * Update a drug register by ID.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateDrugRegister(
        data: $OpenApiTs["/drugs/registers/{drug_register_id}"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/drugs/registers/{drug_register_id}"]["put"]["res"][200]> {
        const { drugRegisterId, name, roomId, allowOrder, status, requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/drugs/registers/{drug_register_id}",
            path: {
                drug_register_id: drugRegisterId,
            },
            query: {
                name,
                room_id: roomId,
                allow_order: allowOrder,
                status,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete Drug Register Endpoint
     * Delete a drug register by ID.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deleteDrugRegister(
        data: $OpenApiTs["/drugs/registers/{drug_register_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/drugs/registers/{drug_register_id}"]["delete"]["res"][200]> {
        const { drugRegisterId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/drugs/registers/{drug_register_id}",
            path: {
                drug_register_id: drugRegisterId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class EmbryosService {
    /**
     * Get Embryo Details
     * Get details of an embryo group.
     * @returns EmbryoDetails Successful Response
     * @throws ApiError
     */
    public static getEmbryoDetails(
        data: $OpenApiTs["/embryos/{embryo_group_key}/details"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/embryos/{embryo_group_key}/details"]["get"]["res"][200]> {
        const { embryoGroupKey } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/embryos/{embryo_group_key}/details",
            path: {
                embryo_group_key: embryoGroupKey,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Embryo History
     * Get history of an embryo group.
     * @returns EmbryoEvent Successful Response
     * @throws ApiError
     */
    public static getEmbryoHistory(
        data: $OpenApiTs["/embryos/{embryo_group_key}/history"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/embryos/{embryo_group_key}/history"]["get"]["res"][200]> {
        const { embryoGroupKey } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/embryos/{embryo_group_key}/history",
            path: {
                embryo_group_key: embryoGroupKey,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Carnegie Stages
     * Get possible carnegie stages (age levels, cell stages) for embryos.
     * @returns EmbryoAgeData Successful Response
     * @throws ApiError
     */
    public static getCarnegieStagesForSetting(): CancelablePromise<
        $OpenApiTs["/embryos/carnegie_stages/for_setting"]["get"]["res"][200]
    > {
        return __request(OpenAPI, {
            method: "GET",
            url: "/embryos/carnegie_stages/for_setting",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Next Free Straw Labels
     * Get next free straw labels for cryopreserved embryos.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getNextFreeEmbryoStrawLabels(
        data: $OpenApiTs["/embryos/straw_labels/for_setting"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/embryos/straw_labels/for_setting"]["get"]["res"][200]> {
        const { count } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/embryos/straw_labels/for_setting",
            query: {
                count,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Foster Mothers By Strain Id
     * Get female animals of the given strain to use them as foster mothers for embryos.
     * @returns FosterMother Successful Response
     * @throws ApiError
     */
    public static getFosterMothersByStrainId(
        data: $OpenApiTs["/embryos/foster_mothers_by_strain_id/{strain_id}"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/embryos/foster_mothers_by_strain_id/{strain_id}"]["get"]["res"][200]> {
        const { strainId, amount } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/embryos/foster_mothers_by_strain_id/{strain_id}",
            path: {
                strain_id: strainId,
            },
            query: {
                amount,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Foster Mother Suffixes
     * Get missing suffixes to assign new eartags to foster mothers on embryo transfer.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getFosterMotherSuffixes(
        data: $OpenApiTs["/embryos/foster_mother_suffixes"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/embryos/foster_mother_suffixes"]["get"]["res"][200]> {
        const { eartags } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/embryos/foster_mother_suffixes",
            query: {
                eartags,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Import Embryos
     * Import embryos.
     * @returns number Successful Response
     * @throws ApiError
     */
    public static importEmbryos(
        data: $OpenApiTs["/embryos/import"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/embryos/import"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/embryos/import",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Quickselect Seed
     * Get seed for embryo Quickselect.
     * @returns EmbryoQuickselectSeed Successful Response
     * @throws ApiError
     */
    public static getEmbryoQuickselectSeed(
        data: $OpenApiTs["/embryos/quickselect/seed"]["put"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/embryos/quickselect/seed"]["put"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/embryos/quickselect/seed",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Apply Quickselect
     * Apply Quickselect actions to selected embryo IDs.
     * @returns EmbryoQuickselectActionsResponse Successful Response
     * @throws ApiError
     */
    public static applyEmbryoQuickselectActions(
        data: $OpenApiTs["/embryos/quickselect/apply"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/embryos/quickselect/apply"]["put"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/embryos/quickselect/apply",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class LicensesService {
    /**
     * Get License Options Endpoint
     * Get the list of licenses for setting a license.
     *
     * Replacement for former:
     * - ajax_service -> get_licence_list_json
     * - ajax_service -> get_licenses_for_association
     * - ajax_service -> get_licenses_for_setting
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getLicenseOptions(
        data: $OpenApiTs["/licenses/license_options"]["get"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/licenses/license_options"]["get"]["res"][200]> {
        const { speciesId, strainId, which, addDelimiter } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/licenses/license_options",
            query: {
                species_id: speciesId,
                strain_id: strainId,
                which,
                add_delimiter: addDelimiter,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get License Classification Options Endpoint
     * Get the list of classifications for setting a license.
     *
     * Replacement for former:
     * - ajax_service -> get_licence_classifications_json
     * - ajax_service -> get_license_classifications_for_association
     * - ajax_service -> get_license_classifications_for_setting
     * - ajax_service -> get_license_classifications_for_filter
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getLicenseClassificationOptions(
        data: $OpenApiTs["/licenses/license/{license_id}/classification_options"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/licenses/license/{license_id}/classification_options"]["get"]["res"][200]> {
        const { licenseId, speciesId, strainId, which, addDelimiter } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/licenses/license/{license_id}/classification_options",
            path: {
                license_id: licenseId,
            },
            query: {
                species_id: speciesId,
                strain_id: strainId,
                which,
                add_delimiter: addDelimiter,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Procedures For Classification Endpoint
     * Get procedures for the given classification.
     *
     * Replacement for former:
     * - ajax_service -> get_procedures_for_classification
     * @returns IdLabelProperty Successful Response
     * @throws ApiError
     */
    public static getProceduresForClassification(
        data: $OpenApiTs["/licenses/classification/{classification_id}/procedures"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/licenses/classification/{classification_id}/procedures"]["get"]["res"][200]> {
        const { classificationId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/licenses/classification/{classification_id}/procedures",
            path: {
                classification_id: classificationId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get License Sign Off Data
     * Get the sign-off details for a license or default (license_id=0).
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getLicenseSignOff(
        data: $OpenApiTs["/licenses/license/{license_id}/sign_off"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/licenses/license/{license_id}/sign_off"]["get"]["res"][200]> {
        const { licenseId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/licenses/license/{license_id}/sign_off",
            path: {
                license_id: licenseId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Post License Sign Off Data
     * Save the sign-off details for a license or the default (license_id=0).
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static saveLicenseSignOff(
        data: $OpenApiTs["/licenses/license/{license_id}/sign_off"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/licenses/license/{license_id}/sign_off"]["post"]["res"][200]> {
        const { licenseId, requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/licenses/license/{license_id}/sign_off",
            path: {
                license_id: licenseId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Set License Dialog Options Endpoint
     * Get the options for setting a license.
     * @returns SetLicenseDialogOptions Successful Response
     * @throws ApiError
     */
    public static getSetLicenseDialogOptions(
        data: $OpenApiTs["/licenses/set_license_dialog_options"]["get"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/licenses/set_license_dialog_options"]["get"]["res"][200]> {
        const { animalId, pupId, tankId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/licenses/set_license_dialog_options",
            query: {
                animal_id: animalId,
                pup_id: pupId,
                tank_id: tankId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Apply Licenses Changes Endpoint
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static applyLicenseAssignments(
        data: $OpenApiTs["/licenses/set_license"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/licenses/set_license"]["post"]["res"][200]> {
        const { requestBody, confirmedLicenseOveruse } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/licenses/set_license",
            query: {
                confirmed_license_overuse: confirmedLicenseOveruse,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class ListViewService {
    /**
     * Get Column Select Params
     * Return the parameters for the Listview view_name.
     * @returns ColumnSelectParams Successful Response
     * @throws ApiError
     */
    public static getColumnSelectParams(
        data: $OpenApiTs["/list_view/{view_name}/column_select"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/list_view/{view_name}/column_select"]["get"]["res"][200]> {
        const { viewName, mode } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/list_view/{view_name}/column_select",
            path: {
                view_name: viewName,
            },
            query: {
                mode,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Post Column Selection
     * Set the selected columns for the Listview view_name.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setColumnSelection(
        data: $OpenApiTs["/list_view/{view_name}/column_select"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/list_view/{view_name}/column_select"]["post"]["res"][200]> {
        const { viewName, requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/list_view/{view_name}/column_select",
            path: {
                view_name: viewName,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Filter Parameters
     * Get list filter "seed" parameters.
     * @returns ListFilterGetResponse Successful Response
     * @throws ApiError
     */
    public static getFilterParameters(
        data: $OpenApiTs["/list_view/{view_name}/filter/parameters"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/list_view/{view_name}/filter/parameters"]["post"]["res"][200]> {
        const { viewName, requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/list_view/{view_name}/filter/parameters",
            path: {
                view_name: viewName,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Filter
     * Set list filter.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setFilter(
        data: $OpenApiTs["/list_view/{view_name}/filter/set"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/list_view/{view_name}/filter/set"]["post"]["res"][200]> {
        const { viewName, requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/list_view/{view_name}/filter/set",
            path: {
                view_name: viewName,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Reset Filter
     * Reset list filter.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static resetFilter(
        data: $OpenApiTs["/list_view/{view_name}/filter/reset"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/list_view/{view_name}/filter/reset"]["post"]["res"][200]> {
        const { viewName, requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/list_view/{view_name}/filter/reset",
            path: {
                view_name: viewName,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Execute Filter Request
     * Set list filter preferences.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setFilterPreferences(
        data: $OpenApiTs["/list_view/{view_name}/filter/set_preferences"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/list_view/{view_name}/filter/set_preferences"]["post"]["res"][200]> {
        const { viewName, requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/list_view/{view_name}/filter/set_preferences",
            path: {
                view_name: viewName,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Filter Preset
     * Set list filter preset.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setFilterPreset(
        data: $OpenApiTs["/list_view/{view_name}/filter/set_preset"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/list_view/{view_name}/filter/set_preset"]["post"]["res"][200]> {
        const { viewName, requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/list_view/{view_name}/filter/set_preset",
            path: {
                view_name: viewName,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Remove Filter Preset
     * Remove filter preset.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static removeFilterPreset(
        data: $OpenApiTs["/list_view/{view_name}/filter/remove_preset"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/list_view/{view_name}/filter/remove_preset"]["post"]["res"][200]> {
        const { viewName, requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/list_view/{view_name}/filter/remove_preset",
            path: {
                view_name: viewName,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Possible Filter Values
     * Get possible filter values.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getPossibleFilterValues(
        data: $OpenApiTs["/list_view/{view_name}/filter/possible_values/{item_name}"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/list_view/{view_name}/filter/possible_values/{item_name}"]["post"]["res"][200]> {
        const { viewName, itemName, requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/list_view/{view_name}/filter/possible_values/{item_name}",
            path: {
                view_name: viewName,
                item_name: itemName,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class LocationsService {
    /**
     * Get Location Detail Seed
     * Get the location detail seed.
     * @returns LocationDetailSeed Successful Response
     * @throws ApiError
     */
    public static getLocationDetails(
        data: $OpenApiTs["/locations/{location_id}/details"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/locations/{location_id}/details"]["get"]["res"][200]> {
        const { locationId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/locations/{location_id}/details",
            path: {
                location_id: locationId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Location Endpoint
     * Update a location from the detail page.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateLocationDetails(
        data: $OpenApiTs["/locations/{location_id}/details"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/locations/{location_id}/details"]["put"]["res"][200]> {
        const { locationId, requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/locations/{location_id}/details",
            path: {
                location_id: locationId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Generate Rack Positions
     * Generate a position matrix for a rack.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static generateRackPositions(
        data: $OpenApiTs["/locations/positions"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/locations/positions"]["get"]["res"][200]> {
        const {
            firstPosition,
            lastPosition,
            rowCount,
            columnCount,
            secondPosition,
            startingPoint,
            countingDirection,
            countingOrder,
        } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/locations/positions",
            query: {
                first_position: firstPosition,
                last_position: lastPosition,
                row_count: rowCount,
                column_count: columnCount,
                second_position: secondPosition,
                starting_point: startingPoint,
                counting_direction: countingDirection,
                counting_order: countingOrder,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete Location Endpoint
     * Delete a location.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deleteLocation(
        data: $OpenApiTs["/locations/{location_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/locations/{location_id}"]["delete"]["res"][200]> {
        const { locationId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/locations/{location_id}",
            path: {
                location_id: locationId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Create Location Endpoint
     * Create a new location.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static createLocation(
        data: $OpenApiTs["/locations/"]["post"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/locations/"]["post"]["res"][200]> {
        const { parentLocationId } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/locations/",
            query: {
                parent_location_id: parentLocationId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Picker Locations
     * Get locations for the location picker.
     * @returns LocationPickerLocation Successful Response
     * @throws ApiError
     */
    public static getPickerLocations(
        data: $OpenApiTs["/locations/picker/locations"]["get"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/locations/picker/locations"]["get"]["res"][200]> {
        const { pickerType, parentLocation, withNoLocation, preselectType, preselectId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/locations/picker/locations",
            query: {
                picker_type: pickerType,
                parent_location: parentLocation,
                with_no_location: withNoLocation,
                preselect_type: preselectType,
                preselect_id: preselectId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Picker Cages
     * Get cages for the location picker
     * @returns LocationPickerCage Successful Response
     * @throws ApiError
     */
    public static getPickerCages(
        data: $OpenApiTs["/locations/picker/cages/{location_id}"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/locations/picker/cages/{location_id}"]["get"]["res"][200]> {
        const { locationId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/locations/picker/cages/{location_id}",
            path: {
                location_id: locationId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Picker Tanks
     * Get tanks for the location picker
     * @returns LocationPickerTankPosition Successful Response
     * @throws ApiError
     */
    public static getPickerTanks(
        data: $OpenApiTs["/locations/picker/tanks/{location_id}"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/locations/picker/tanks/{location_id}"]["get"]["res"][200]> {
        const { locationId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/locations/picker/tanks/{location_id}",
            path: {
                location_id: locationId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class MutationsService {
    /**
     * Deactivate Mutation Endpoint
     * Deactivate a mutation.
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static deactivateMutation(
        data: $OpenApiTs["/mutations/{mutation_id}/active"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/mutations/{mutation_id}/active"]["delete"]["res"][200]> {
        const { mutationId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/mutations/{mutation_id}/active",
            path: {
                mutation_id: mutationId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Activate Mutation Endpoint
     * Activate a mutation.
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static activateMutation(
        data: $OpenApiTs["/mutations/{mutation_id}/active"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/mutations/{mutation_id}/active"]["put"]["res"][200]> {
        const { mutationId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/mutations/{mutation_id}/active",
            path: {
                mutation_id: mutationId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Mutation Grades
     * Get grade list according to the specified mutation id.
     * @returns IdNameProperty Successful Response
     * @throws ApiError
     */
    public static getMutationGrades(
        data: $OpenApiTs["/mutations/{mutation_id}/grades"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/mutations/{mutation_id}/grades"]["get"]["res"][200]> {
        const { mutationId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/mutations/{mutation_id}/grades",
            path: {
                mutation_id: mutationId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class OriginsService {
    /**
     * Get Origins For Setting
     * Get the list of origins for setting an origin.
     * @returns IdNameProperty Successful Response
     * @throws ApiError
     */
    public static getOriginsForSetting(): CancelablePromise<$OpenApiTs["/origins/for_setting"]["get"]["res"][200]> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/origins/for_setting",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Deactivate Origin Endpoint
     * Deactivate an origin.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deactivateOrigin(
        data: $OpenApiTs["/origins/{origin_id}/active"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/origins/{origin_id}/active"]["delete"]["res"][200]> {
        const { originId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/origins/{origin_id}/active",
            path: {
                origin_id: originId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Activate Origin Endpoint
     * Activate an origin.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static activateOrigin(
        data: $OpenApiTs["/origins/{origin_id}/active"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/origins/{origin_id}/active"]["put"]["res"][200]> {
        const { originId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/origins/{origin_id}/active",
            path: {
                origin_id: originId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete Origin Endpoint
     * Delete an origin.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deleteOrigin(
        data: $OpenApiTs["/origins/{origin_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/origins/{origin_id}"]["delete"]["res"][200]> {
        const { originId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/origins/{origin_id}",
            path: {
                origin_id: originId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class PrintoutService {
    /**
     * Get Cage Label Printer Preference
     * Check we should offer a list of printers, send to a predefined printer or show the card in the browser.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getCageLabelPrinterPreference(
        data: $OpenApiTs["/printout/preference"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/printout/preference"]["get"]["res"][200]> {
        const { cageId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/printout/preference",
            query: {
                cage_id: cageId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Send Cage Label To Printer
     * Send the cage label to the printer.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static sendCageLabelToPrinter(
        data: $OpenApiTs["/printout/print"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/printout/print"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/printout/print",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class ProceduresService {
    /**
     * Post Procedure
     * Add procedure
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static addProcedure(
        data: $OpenApiTs["/procedures/"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/procedures/"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/procedures/",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete Procedure
     * Remove procedure
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static removeProcedure(
        data: $OpenApiTs["/procedures/"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/procedures/"]["delete"]["res"][200]> {
        const { assignId, animalId, pupId, tankId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/procedures/",
            query: {
                assign_id: assignId,
                animal_id: animalId,
                pup_id: pupId,
                tank_id: tankId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class ProjectsService {
    /**
     * Get Projects For Setting Endpoint
     * Get the list of projects for setting a project.
     * @returns ProjectForSetting Successful Response
     * @throws ApiError
     */
    public static getProjectsForSetting(
        data: $OpenApiTs["/projects/for_setting"]["get"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/projects/for_setting"]["get"]["res"][200]> {
        const { includeIds } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/projects/for_setting",
            query: {
                include_ids: includeIds,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Deactivate Project Endpoint
     * Deactivate a project.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deactivateProject(
        data: $OpenApiTs["/projects/{project_id}/active"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/projects/{project_id}/active"]["delete"]["res"][200]> {
        const { projectId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/projects/{project_id}/active",
            path: {
                project_id: projectId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Reactivate Project Endpoint
     * (Re)activate a project.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static activateProject(
        data: $OpenApiTs["/projects/{project_id}/active"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/projects/{project_id}/active"]["put"]["res"][200]> {
        const { projectId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/projects/{project_id}/active",
            path: {
                project_id: projectId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete Project Endpoint
     * Delete a project.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deleteProject(
        data: $OpenApiTs["/projects/{project_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/projects/{project_id}"]["delete"]["res"][200]> {
        const { projectId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/projects/{project_id}",
            path: {
                project_id: projectId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Project Endpoint
     * Update an existing project.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateProject(
        data: $OpenApiTs["/projects/{project_id}"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/projects/{project_id}"]["put"]["res"][200]> {
        const { projectId, name, ownerId, categoryId, expirationDate, budgetId, description } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/projects/{project_id}",
            path: {
                project_id: projectId,
            },
            query: {
                name,
                owner_id: ownerId,
                category_id: categoryId,
                expiration_date: expirationDate,
                budget_id: budgetId,
                description,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Project Categories Endpoint
     * Update the project categories.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateProjectCategories(
        data: $OpenApiTs["/projects/categories"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/projects/categories"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/projects/categories",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Project Details Endpoint
     * Get project details.
     * @returns GetProjectDetailsResponse Successful Response
     * @throws ApiError
     */
    public static getProjectDetails(
        data: $OpenApiTs["/projects/details"]["get"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/projects/details"]["get"]["res"][200]> {
        const { projectId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/projects/details",
            query: {
                project_id: projectId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Add User To Projec Endpont
     * Add a user to a project.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static addUserToProject(
        data: $OpenApiTs["/projects/{project_id}/users"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/projects/{project_id}/users"]["post"]["res"][200]> {
        const { projectId, userId } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/projects/{project_id}/users",
            path: {
                project_id: projectId,
            },
            query: {
                user_id: userId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Remove User From Project Endpoint
     * Remove a user from a project.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static removeUserFromProject(
        data: $OpenApiTs["/projects/{project_id}/users/{user_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/projects/{project_id}/users/{user_id}"]["delete"]["res"][200]> {
        const { projectId, userId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/projects/{project_id}/users/{user_id}",
            path: {
                project_id: projectId,
                user_id: userId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Create Project Budget Endpoint
     * Create a new project budget.
     * @returns CreateProjectBudgetResponse Successful Response
     * @throws ApiError
     */
    public static createProjectBudget(
        data: $OpenApiTs["/projects/budgets"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/projects/budgets"]["post"]["res"][200]> {
        const { name } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/projects/budgets",
            query: {
                name,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Create Project Endpoint
     * Create a new project.
     *
     * :return: New project id.
     * @returns number Successful Response
     * @throws ApiError
     */
    public static createProject(
        data: $OpenApiTs["/projects/"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/projects/"]["post"]["res"][200]> {
        const { name, ownerId, categoryId, expirationDate, budgetId, description } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/projects/",
            query: {
                name,
                owner_id: ownerId,
                category_id: categoryId,
                expiration_date: expirationDate,
                budget_id: budgetId,
                description,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class PupsService {
    /**
     * Get Pup Detail Data Endpoint
     * Get data for pup detail dialog.
     * @returns PupDetailData Successful Response
     * @throws ApiError
     */
    public static getPupDetailData(
        data: $OpenApiTs["/pups/{pup_id}/details"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/details"]["get"]["res"][200]> {
        const { pupId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/pups/{pup_id}/details",
            path: {
                pup_id: pupId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Pup Pedigree Dialog Data Endpoint
     * Get data for pup pedigree dialog.
     * @returns PupPedigreeDialogData Successful Response
     * @throws ApiError
     */
    public static getPupPedigreeDialogData(
        data: $OpenApiTs["/pups/{pup_id}/pedigree"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/pedigree"]["get"]["res"][200]> {
        const { pupId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/pups/{pup_id}/pedigree",
            path: {
                pup_id: pupId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Pup Cohort Id Endpoint
     * Get the cohort id for a pup.
     * @returns GetAnimalCohortIdResponse Successful Response
     * @throws ApiError
     */
    public static getPupCohortId(
        data: $OpenApiTs["/pups/{pup_id}/cohort_id"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/cohort_id"]["get"]["res"][200]> {
        const { pupId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/pups/{pup_id}/cohort_id",
            path: {
                pup_id: pupId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Pup Cohort Id Endpoint
     * Set the cohort id for a pup.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setPupCohortId(
        data: $OpenApiTs["/pups/{pup_id}/cohort_id"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/cohort_id"]["put"]["res"][200]> {
        const { pupId, cohortId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/pups/{pup_id}/cohort_id",
            path: {
                pup_id: pupId,
            },
            query: {
                cohort_id: cohortId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Pup Eartag Endpoint
     * Get eartag for a pup.
     * @returns GetAnimalEartagResponse Successful Response
     * @throws ApiError
     */
    public static getPupEartag(
        data: $OpenApiTs["/pups/{pup_id}/eartag"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/eartag"]["get"]["res"][200]> {
        const { pupId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/pups/{pup_id}/eartag",
            path: {
                pup_id: pupId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Pup Eartag Endpoint
     * Set eartag for a pup.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setPupEartag(
        data: $OpenApiTs["/pups/{pup_id}/eartag"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/eartag"]["put"]["res"][200]> {
        const { pupId, prefix, suffix } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/pups/{pup_id}/eartag",
            path: {
                pup_id: pupId,
            },
            query: {
                prefix,
                suffix,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Pup Generation Endpoint
     * Get generation for a pup.
     * @returns GetAnimalGenerationResponse Successful Response
     * @throws ApiError
     */
    public static getPupGeneration(
        data: $OpenApiTs["/pups/{pup_id}/generation"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/generation"]["get"]["res"][200]> {
        const { pupId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/pups/{pup_id}/generation",
            path: {
                pup_id: pupId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Pup Generation Endpoint
     * Set generation for a pup.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setPupGeneration(
        data: $OpenApiTs["/pups/{pup_id}/generation"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/generation"]["put"]["res"][200]> {
        const { pupId, requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/pups/{pup_id}/generation",
            path: {
                pup_id: pupId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Pup Genetic Background Endpoint
     * Get genetic background for a pup.
     * @returns GetAnimalGeneticBackgroundResponse Successful Response
     * @throws ApiError
     */
    public static getPupGeneticBackground(
        data: $OpenApiTs["/pups/{pup_id}/genetic_background"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/genetic_background"]["get"]["res"][200]> {
        const { pupId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/pups/{pup_id}/genetic_background",
            path: {
                pup_id: pupId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Pup Genetic Background Endpoint
     * Set genetic background for a pup.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setPupGeneticBackground(
        data: $OpenApiTs["/pups/{pup_id}/genetic_background"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/genetic_background"]["put"]["res"][200]> {
        const { pupId, geneticBackgroundId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/pups/{pup_id}/genetic_background",
            path: {
                pup_id: pupId,
            },
            query: {
                genetic_background_id: geneticBackgroundId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Pup Projects Endpoint
     * Get all projects assigned to a pup
     * @returns AnimalProjectOption Successful Response
     * @throws ApiError
     */
    public static getPupProjects(
        data: $OpenApiTs["/pups/{pup_id}/projects"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/projects"]["get"]["res"][200]> {
        const { pupId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/pups/{pup_id}/projects",
            path: {
                pup_id: pupId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Add Pup Projects Endpoint
     * Assign projects to a pup
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static addPupProjects(
        data: $OpenApiTs["/pups/{pup_id}/projects"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/projects"]["post"]["res"][200]> {
        const { pupId, projectIds } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/pups/{pup_id}/projects",
            path: {
                pup_id: pupId,
            },
            query: {
                project_ids: projectIds,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Remove Pup Projects Endpoint
     * Remove projects from a pup
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static removePupProjects(
        data: $OpenApiTs["/pups/{pup_id}/projects"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/projects"]["delete"]["res"][200]> {
        const { pupId, projectIds } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/pups/{pup_id}/projects",
            path: {
                pup_id: pupId,
            },
            query: {
                project_ids: projectIds,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Pup Incompatible Sanitary Status Locations Endpoint
     * Get incompatible sanitary status locations for pups based on given new cage or rack id.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getPupIncompatibleSanitaryStatusLocations(
        data: $OpenApiTs["/pups/incompatible_sanitary_status_locations"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/incompatible_sanitary_status_locations"]["get"]["res"][200]> {
        const { pupIds, newCageId, newRackId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/pups/incompatible_sanitary_status_locations",
            query: {
                pup_ids: pupIds,
                new_cage_id: newCageId,
                new_rack_id: newRackId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Pup Lab Id Endpoint
     * Get lab id for a pup.
     * @returns GetAnimalLabIdResponse Successful Response
     * @throws ApiError
     */
    public static getPupLabId(
        data: $OpenApiTs["/pups/{pup_id}/lab_id"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/lab_id"]["get"]["res"][200]> {
        const { pupId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/pups/{pup_id}/lab_id",
            path: {
                pup_id: pupId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Pup Lab Id Endpoint
     * Set lab id for a pup.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setPupLabId(
        data: $OpenApiTs["/pups/{pup_id}/lab_id"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/lab_id"]["put"]["res"][200]> {
        const { pupId, labId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/pups/{pup_id}/lab_id",
            path: {
                pup_id: pupId,
            },
            query: {
                lab_id: labId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Pup Medical Condition Dialog Seed Endpoint
     * Get details for the pup SetMedicalConditions-Dialog.
     * @returns AnimalMedicalConditionDialogSeed Successful Response
     * @throws ApiError
     */
    public static getPupMedicalConditionDialogSeed(
        data: $OpenApiTs["/pups/{pup_id}/medical_condition_dialog"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/medical_condition_dialog"]["get"]["res"][200]> {
        const { pupId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/pups/{pup_id}/medical_condition_dialog",
            path: {
                pup_id: pupId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Pup Medical Conditions Endpoint
     * Set medical conditions for a pup.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setPupMedicalConditions(
        data: $OpenApiTs["/pups/{pup_id}/medical_conditions"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/medical_conditions"]["put"]["res"][200]> {
        const { pupId, requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/pups/{pup_id}/medical_conditions",
            path: {
                pup_id: pupId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Pup Mutation Dialog Seed Endpoint
     * Get details for the pup SetMutation-Dialog.
     * @returns AnimalMutationDialogSeed Successful Response
     * @throws ApiError
     */
    public static getPupMutationDialogSeed(
        data: $OpenApiTs["/pups/{pup_id}/mutation_dialog"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/mutation_dialog"]["get"]["res"][200]> {
        const { pupId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/pups/{pup_id}/mutation_dialog",
            path: {
                pup_id: pupId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Pup Mutations Endpoint
     * Set mutations for a pup.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setPupMutations(
        data: $OpenApiTs["/pups/{pup_id}/mutations"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/mutations"]["put"]["res"][200]> {
        const { pupId, requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/pups/{pup_id}/mutations",
            path: {
                pup_id: pupId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Pup Owner Dialog Seed Endpoint
     * Get details for the pup SetOwner-Dialog.
     * @returns AnimalOwnerDialogSeed Successful Response
     * @throws ApiError
     */
    public static getPupOwnerDialogSeed(
        data: $OpenApiTs["/pups/{pup_id}/owner_dialog"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/owner_dialog"]["get"]["res"][200]> {
        const { pupId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/pups/{pup_id}/owner_dialog",
            path: {
                pup_id: pupId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Pup Owner Endpoint
     * Set owner for a pup.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setPupOwner(
        data: $OpenApiTs["/pups/{pup_id}/owner"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/owner"]["put"]["res"][200]> {
        const { pupId, ownerId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/pups/{pup_id}/owner",
            path: {
                pup_id: pupId,
            },
            query: {
                owner_id: ownerId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Pup Responsible Dialog Seed Endpoint
     * Get details for the pup SetResponsible-Dialog.
     * @returns AnimalResponsibleDialogSeed Successful Response
     * @throws ApiError
     */
    public static getPupResponsibleDialogSeed(
        data: $OpenApiTs["/pups/{pup_id}/responsible_dialog"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/responsible_dialog"]["get"]["res"][200]> {
        const { pupId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/pups/{pup_id}/responsible_dialog",
            path: {
                pup_id: pupId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Pup Responsible Endpoint
     * Set responsible for a pup.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setPupResponsible(
        data: $OpenApiTs["/pups/{pup_id}/responsible"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/responsible"]["put"]["res"][200]> {
        const { pupId, responsibleId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/pups/{pup_id}/responsible",
            path: {
                pup_id: pupId,
            },
            query: {
                responsible_id: responsibleId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Pup Sex Move Sacrifice Dialog Seed Endpoint
     * Get details for the pup SetSexMoveSacrifice-Dialog.
     * @returns AnimalSexMoveSacrificeDialogSeed Successful Response
     * @throws ApiError
     */
    public static getPupSexMoveSacrificeDialogSeed(
        data: $OpenApiTs["/pups/{pup_id}/sex_move_sacrifice_dialog"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/sex_move_sacrifice_dialog"]["get"]["res"][200]> {
        const { pupId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/pups/{pup_id}/sex_move_sacrifice_dialog",
            path: {
                pup_id: pupId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Add Pup To Request Selection Endpoint
     * Add a pup to request selection.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static addPupToRequestSelection(
        data: $OpenApiTs["/pups/{pup_id}/add_to_request_selection"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/add_to_request_selection"]["put"]["res"][200]> {
        const { pupId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/pups/{pup_id}/add_to_request_selection",
            path: {
                pup_id: pupId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Note Pup In Action Log Endpoint
     * Add note for a pup to action log.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static notePupInActionLog(
        data: $OpenApiTs["/pups/{pup_id}/note_in_action_log"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/note_in_action_log"]["put"]["res"][200]> {
        const { pupId, eartagOrId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/pups/{pup_id}/note_in_action_log",
            path: {
                pup_id: pupId,
            },
            query: {
                eartag_or_id: eartagOrId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Resurrect Pup Endpoint
     * Resurrect a pup.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static resurrectPup(
        data: $OpenApiTs["/pups/{pup_id}/resurrect"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/resurrect"]["put"]["res"][200]> {
        const { pupId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/pups/{pup_id}/resurrect",
            path: {
                pup_id: pupId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Sacrifice Pup Endpoint
     * Sacrifice a pup.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static sacrificePup(
        data: $OpenApiTs["/pups/{pup_id}/sacrifice"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/sacrifice"]["put"]["res"][200]> {
        const {
            pupId,
            comment,
            sacrificeReasonId,
            sacrificeMethodId,
            severityLevelId,
            classificationId,
            confirmedLicenseOveruse,
            replaceCurrentLicense,
            keepLicence,
        } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/pups/{pup_id}/sacrifice",
            path: {
                pup_id: pupId,
            },
            query: {
                comment,
                sacrifice_reason_id: sacrificeReasonId,
                sacrifice_method_id: sacrificeMethodId,
                severity_level_id: severityLevelId,
                classification_id: classificationId,
                confirmed_license_overuse: confirmedLicenseOveruse,
                replace_current_license: replaceCurrentLicense,
                keep_licence: keepLicence,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Pup Birth Date Endpoint
     * Update birthdate for a pup.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updatePupBirthDate(
        data: $OpenApiTs["/pups/{pup_id}/birth_date"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/birth_date"]["put"]["res"][200]> {
        const { pupId, birthDate } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/pups/{pup_id}/birth_date",
            path: {
                pup_id: pupId,
            },
            query: {
                birth_date: birthDate,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Pup Sacrifice Date Endpoint
     * Update sacrifice date for a pup.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updatePupSacrificeDate(
        data: $OpenApiTs["/pups/{pup_id}/sacrifice_date"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/sacrifice_date"]["put"]["res"][200]> {
        const { pupId, sacrificeDate } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/pups/{pup_id}/sacrifice_date",
            path: {
                pup_id: pupId,
            },
            query: {
                sacrifice_date: sacrificeDate,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Pup Sex Endpoint
     * Set sex of a pup.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setPupSex(
        data: $OpenApiTs["/pups/{pup_id}/sex"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/sex"]["put"]["res"][200]> {
        const { pupId, sex } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/pups/{pup_id}/sex",
            path: {
                pup_id: pupId,
            },
            query: {
                sex,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Pup Species Dialog Seed Endpoint
     * Get details for the pup SetSpecies-Dialog.
     * @returns AnimalSpeciesDialogSeed Successful Response
     * @throws ApiError
     */
    public static getPupSpeciesDialogSeed(
        data: $OpenApiTs["/pups/{pup_id}/species_dialog"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/species_dialog"]["get"]["res"][200]> {
        const { pupId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/pups/{pup_id}/species_dialog",
            path: {
                pup_id: pupId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Pup Species Endpoint
     * Set species for pup.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setPupSpecies(
        data: $OpenApiTs["/pups/{pup_id}/species"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/species"]["put"]["res"][200]> {
        const { pupId, speciesId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/pups/{pup_id}/species",
            path: {
                pup_id: pupId,
            },
            query: {
                species_id: speciesId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Pup Strain Dialog Seed Endpoint
     * Get details for the pup SetStrain-Dialog.
     * @returns AnimalStrainDialogSeed Successful Response
     * @throws ApiError
     */
    public static getPupStrainDialogSeed(
        data: $OpenApiTs["/pups/{pup_id}/strain_dialog"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/strain_dialog"]["get"]["res"][200]> {
        const { pupId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/pups/{pup_id}/strain_dialog",
            path: {
                pup_id: pupId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Pup Strain Endpoint
     * Set strain for pup.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setPupStrain(
        data: $OpenApiTs["/pups/{pup_id}/strain"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/strain"]["put"]["res"][200]> {
        const { pupId, strainId, keepMutation, setSpeciesToStrain } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/pups/{pup_id}/strain",
            path: {
                pup_id: pupId,
            },
            query: {
                strain_id: strainId,
                keep_mutation: keepMutation,
                set_species_to_strain: setSpeciesToStrain,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Pup Weight Dialog Seed Endpoint
     * Get details for the pup setWeight-Dialog.
     * @returns AnimalWeightDialogSeed Successful Response
     * @throws ApiError
     */
    public static getPupWeightDialogSeed(
        data: $OpenApiTs["/pups/{pup_id}/weight_dialog_seed"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/weight_dialog_seed"]["get"]["res"][200]> {
        const { pupId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/pups/{pup_id}/weight_dialog_seed",
            path: {
                pup_id: pupId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Pup Weight Endpoint
     * Set weight for pup.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static addPupWeight(
        data: $OpenApiTs["/pups/{pup_id}/weight"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/weight"]["post"]["res"][200]> {
        const { pupId, requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/pups/{pup_id}/weight",
            path: {
                pup_id: pupId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Unset Pup Reference Weight Endpoint
     * Unset reference weight for pup.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static unsetPupReferenceWeight(
        data: $OpenApiTs["/pups/{pup_id}/reference-weight"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/reference-weight"]["delete"]["res"][200]> {
        const { pupId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/pups/{pup_id}/reference-weight",
            path: {
                pup_id: pupId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete Pup Weight Endpoint
     * Delete weight for pup.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deletePupWeight(
        data: $OpenApiTs["/pups/{pup_id}/weight/{weight_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/pups/{pup_id}/weight/{weight_id}"]["delete"]["res"][200]> {
        const { weightId, pupId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/pups/{pup_id}/weight/{weight_id}",
            path: {
                weight_id: weightId,
                pup_id: pupId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class ReportsService {
    /**
     * Get Breeding Performance Details
     * Get data for breeding performance details dialog.
     * @returns BreedingPerformanceDetails Successful Response
     * @throws ApiError
     */
    public static getBreedingPerformanceDetails(
        data: $OpenApiTs["/reports/breeding_performance_details"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/reports/breeding_performance_details"]["get"]["res"][200]> {
        const { animalId, birthDateFrom, birthDateTo } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/reports/breeding_performance_details",
            query: {
                animal_id: animalId,
                birth_date_from: birthDateFrom,
                birth_date_to: birthDateTo,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Colony Pedigree
     * Get colony pedigree.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getColonyPedigree(
        data: $OpenApiTs["/reports/colony_pedigree"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/reports/colony_pedigree"]["get"]["res"][200]> {
        const { kind, label, nearby, depth } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/reports/colony_pedigree",
            query: {
                kind,
                label,
                nearby,
                depth,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class SacrificeMethodsService {
    /**
     * Update Sacrifice Methods
     * Update the sacrifice methods.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateSacrificeMethods(
        data: $OpenApiTs["/sacrifice_methods/"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/sacrifice_methods/"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/sacrifice_methods/",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class SacrificeReasonsService {
    /**
     * Update Sacrifice Reasons
     * Change data of multiple sacrifice reasons at once and roll back on error.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateSacrificeReasons(
        data: $OpenApiTs["/sacrifice_reasons/"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/sacrifice_reasons/"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/sacrifice_reasons/",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class ScheduledReportsService {
    /**
     * Get Report Details Endpoint
     * Returns details of a scheduled report
     * @returns ScheduledReport Successful Response
     * @throws ApiError
     */
    public static getReportDetails(
        data: $OpenApiTs["/scheduled_reports/report/{report_id}"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/scheduled_reports/report/{report_id}"]["get"]["res"][200]> {
        const { reportId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/scheduled_reports/report/{report_id}",
            path: {
                report_id: reportId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Report Endpoint
     * Update a scheduled report
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static updateReport(
        data: $OpenApiTs["/scheduled_reports/report/{report_id}"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/scheduled_reports/report/{report_id}"]["put"]["res"][200]> {
        const { reportId, requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/scheduled_reports/report/{report_id}",
            path: {
                report_id: reportId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete Report Endpoint
     * Delete a scheduled report
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static deleteReport(
        data: $OpenApiTs["/scheduled_reports/report/{report_id}"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/scheduled_reports/report/{report_id}"]["post"]["res"][200]> {
        const { reportId } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/scheduled_reports/report/{report_id}",
            path: {
                report_id: reportId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Available Reports Endpoint
     * Returns a list of available reports
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getAvailableReports(): CancelablePromise<
        $OpenApiTs["/scheduled_reports/available_reports"]["get"]["res"][200]
    > {
        return __request(OpenAPI, {
            method: "GET",
            url: "/scheduled_reports/available_reports",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Available Repetitions Endpoint
     * Returns a list of available repetitions
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getAvailableRepetitions(): CancelablePromise<
        $OpenApiTs["/scheduled_reports/available_repetitions"]["get"]["res"][200]
    > {
        return __request(OpenAPI, {
            method: "GET",
            url: "/scheduled_reports/available_repetitions",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Post Report Endpoint
     * Schedule a report
     * @returns number Successful Response
     * @throws ApiError
     */
    public static scheduleReport(
        data: $OpenApiTs["/scheduled_reports/report"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/scheduled_reports/report"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/scheduled_reports/report",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class SessionService {
    /**
     * Get Session Time
     * Get the time left until the session ends.
     * @returns number Successful Response
     * @throws ApiError
     */
    public static getSessionTime(
        data: $OpenApiTs["/session/session_time"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/session/session_time"]["get"]["res"][200]> {
        const { sessionid } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/session/session_time",
            query: {
                sessionid,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Reactivate Session
     * Try to resurrect the session (re-open an expired session by giving the credentials).
     * @returns true Successful Response
     * @throws ApiError
     */
    public static reactivateSession(
        data: $OpenApiTs["/session/reactivate_session"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/session/reactivate_session"]["post"]["res"][200]> {
        const { sessionid, requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/session/reactivate_session",
            query: {
                sessionid,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get User Aliases
     * Get the aliases of the user.
     * @returns UserAlias Successful Response
     * @throws ApiError
     */
    public static getAliases(): CancelablePromise<$OpenApiTs["/session/aliases"]["get"]["res"][200]> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/session/aliases",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class SeverityAssessmentSheetService {
    /**
     * Delete Assessment Sheet Endpoint
     * Delete an assessment drug by ID.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deleteAssessmentSheet(
        data: $OpenApiTs["/sheets/{assessment_sheet_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/sheets/{assessment_sheet_id}"]["delete"]["res"][200]> {
        const { assessmentSheetId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/sheets/{assessment_sheet_id}",
            path: {
                assessment_sheet_id: assessmentSheetId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class SeverityAssessmentTemplateService {
    /**
     * Get Template Details Endpoint
     * Get details for a template
     * @returns TemplateDetailsResponse Successful Response
     * @throws ApiError
     */
    public static getSeverityAssessmentTemplateDetails(
        data: $OpenApiTs["/template/details"]["get"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/template/details"]["get"]["res"][200]> {
        const { templateId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/template/details",
            query: {
                template_id: templateId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Create Template Endpoint
     * Create a new template
     * @returns number Successful Response
     * @throws ApiError
     */
    public static createSeverityAssessmentTemplate(
        data: $OpenApiTs["/template/"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/template/"]["post"]["res"][200]> {
        const { name, templateType, requestBody, expirationDate } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/template/",
            query: {
                name,
                template_type: templateType,
                expiration_date: expirationDate,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Template Endpoint
     * Update an existing template
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateSeverityAssessmentTemplate(
        data: $OpenApiTs["/template/{template_id}"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/template/{template_id}"]["put"]["res"][200]> {
        const { templateId, name, available, templateType, requestBody, expirationDate } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/template/{template_id}",
            path: {
                template_id: templateId,
            },
            query: {
                name,
                available,
                template_type: templateType,
                expiration_date: expirationDate,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class SeverityLevelsService {
    /**
     * Get Severity Level Details Endpoint
     * Get details for a severity level
     * @returns SeverityLevelDetailsResponse Successful Response
     * @throws ApiError
     */
    public static getSeverityLevelDetails(
        data: $OpenApiTs["/severity_levels/details"]["get"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/severity_levels/details"]["get"]["res"][200]> {
        const { severityLevelId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/severity_levels/details",
            query: {
                severity_level_id: severityLevelId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Severity Levels
     * Get the list of severity levels to select for assignment.
     * @returns SeverityLevelOption Successful Response
     * @throws ApiError
     */
    public static getSeverityLevelOptions(
        data: $OpenApiTs["/severity_levels/"]["get"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/severity_levels/"]["get"]["res"][200]> {
        const { available, requestBody } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/severity_levels/",
            query: {
                available,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Create Severity Level Endpoint
     * Create a new severity level
     * @returns number Successful Response
     * @throws ApiError
     */
    public static createSeverityLevel(
        data: $OpenApiTs["/severity_levels/"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/severity_levels/"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/severity_levels/",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Severity Level Endpoint
     * Update an existing severity level
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateSeverityLevel(
        data: $OpenApiTs["/severity_levels/{severity_level_id}"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/severity_levels/{severity_level_id}"]["put"]["res"][200]> {
        const { severityLevelId, requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/severity_levels/{severity_level_id}",
            path: {
                severity_level_id: severityLevelId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete Severity Level Endpoint
     * Delete an existing severity level
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deleteSeverityLevel(
        data: $OpenApiTs["/severity_levels/{severity_level_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/severity_levels/{severity_level_id}"]["delete"]["res"][200]> {
        const { severityLevelId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/severity_levels/{severity_level_id}",
            path: {
                severity_level_id: severityLevelId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class SpermService {
    /**
     * Get Sperm Details
     * Get sperm details.
     * @returns SpermDetails Successful Response
     * @throws ApiError
     */
    public static getSpermDetails(
        data: $OpenApiTs["/sperm/{sperm_id}/details"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/sperm/{sperm_id}/details"]["get"]["res"][200]> {
        const { spermId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/sperm/{sperm_id}/details",
            path: {
                sperm_id: spermId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Sperm History
     * Get sperm history.
     * @returns SpermEvent Successful Response
     * @throws ApiError
     */
    public static getSpermHistory(
        data: $OpenApiTs["/sperm/{sperm_id}/history"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/sperm/{sperm_id}/history"]["get"]["res"][200]> {
        const { spermId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/sperm/{sperm_id}/history",
            path: {
                sperm_id: spermId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Sperm Qualities
     * Get sperm quality options.
     * @returns QualityProperties Successful Response
     * @throws ApiError
     */
    public static getSpermQualitiesForSetting(): CancelablePromise<
        $OpenApiTs["/sperm/qualities/for_setting"]["get"]["res"][200]
    > {
        return __request(OpenAPI, {
            method: "GET",
            url: "/sperm/qualities/for_setting",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Next Free Straw Labels
     * Get next free straw labels for cryopreserved sperm.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getNextFreeSpermStrawLabels(
        data: $OpenApiTs["/sperm/straw_labels/for_setting"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/sperm/straw_labels/for_setting"]["get"]["res"][200]> {
        const { count } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/sperm/straw_labels/for_setting",
            query: {
                count,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Oocyte Donors By Strain
     * Get female animals of a certain strain for selection as oocyte donors.
     * @returns OocyteDonor Successful Response
     * @throws ApiError
     */
    public static getOocyteDonorsByStrainForSetting(
        data: $OpenApiTs["/sperm/oocyte_donors_by_strain/{strain_id}/for_setting"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/sperm/oocyte_donors_by_strain/{strain_id}/for_setting"]["get"]["res"][200]> {
        const { strainId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/sperm/oocyte_donors_by_strain/{strain_id}/for_setting",
            path: {
                strain_id: strainId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Import Sperm
     * Import sperm.
     * @returns number Successful Response
     * @throws ApiError
     */
    public static importSperm(
        data: $OpenApiTs["/sperm/import"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/sperm/import"]["post"]["res"][200]> {
        const {
            volume,
            originId,
            ownerId,
            projectId,
            strainId,
            qualityRating,
            qualityProgressivePortion,
            cryopreserved,
            requestBody,
        } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/sperm/import",
            query: {
                volume,
                origin_id: originId,
                owner_id: ownerId,
                project_id: projectId,
                strain_id: strainId,
                quality_rating: qualityRating,
                quality_progressive_portion: qualityProgressivePortion,
                cryopreserved,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Quickselect Seed
     * Get seed for sperm Quickselect.
     * @returns SpermQuickselectSeed Successful Response
     * @throws ApiError
     */
    public static getSpermQuickselectSeed(
        data: $OpenApiTs["/sperm/quickselect/seed"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/sperm/quickselect/seed"]["put"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/sperm/quickselect/seed",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Apply Quickselect
     * Apply Quickselect actions to selected sperm IDs.
     * @returns SpermQuickselectActionsResponse Successful Response
     * @throws ApiError
     */
    public static applySpermQuickselectActions(
        data: $OpenApiTs["/sperm/quickselect/apply"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/sperm/quickselect/apply"]["put"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/sperm/quickselect/apply",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class StrainsService {
    /**
     * List Strain Options
     * @returns StrainOption Successful Response
     * @throws ApiError
     */
    public static getStrainsForSetting(
        data: $OpenApiTs["/strains/for_setting"]["get"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/strains/for_setting"]["get"]["res"][200]> {
        const { status, used, ownerUserId, permittedUser } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/strains/for_setting",
            query: {
                status,
                used,
                owner_user_id: ownerUserId,
                permitted_user: permittedUser,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * List Strain Options
     * @returns StrainOption Successful Response
     * @throws ApiError
     */
    public static getStrainsForFilter(
        data: $OpenApiTs["/strains/for_filter"]["get"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/strains/for_filter"]["get"]["res"][200]> {
        const { status, used, ownerUserId, permittedUser } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/strains/for_filter",
            query: {
                status,
                used,
                owner_user_id: ownerUserId,
                permitted_user: permittedUser,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Strain Block Details
     * Get details for blocking a strain.
     * @returns StrainBlockDetails Successful Response
     * @throws ApiError
     */
    public static getStrainBlockDetails(
        data: $OpenApiTs["/strains/{strain_id}/block"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/strains/{strain_id}/block"]["get"]["res"][200]> {
        const { strainId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/strains/{strain_id}/block",
            path: {
                strain_id: strainId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Block Strain
     * Block a strain.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static blockStrain(
        data: $OpenApiTs["/strains/{strain_id}/block"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/strains/{strain_id}/block"]["put"]["res"][200]> {
        const { strainId, action, reassignTo } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/strains/{strain_id}/block",
            path: {
                strain_id: strainId,
            },
            query: {
                action,
                reassign_to: reassignTo,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Unblock Strain
     * Unblock a strain.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static unblockStrain(
        data: $OpenApiTs["/strains/{strain_id}/block"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/strains/{strain_id}/block"]["delete"]["res"][200]> {
        const { strainId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/strains/{strain_id}/block",
            path: {
                strain_id: strainId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Strains By Sex For Owners
     * Get strains for filter depending on the selected owner
     *
     * Send result as JSON response to client (a dict containing the strains divided by sex).
     *
     * :param owner_ids: '__all_for_alias__' to get strains of all aliases of the user's alias;
     * or ID(s) of scientist strains shall be fetched for
     * or Empty to get strains of all the user's aliases
     * @returns StrainsBySexForOwners Successful Response
     * @throws ApiError
     */
    public static getStrainsBySexForOwners(
        data: $OpenApiTs["/strains/strains_by_sex_for_owners"]["get"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/strains/strains_by_sex_for_owners"]["get"]["res"][200]> {
        const { ownerIds } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/strains/strains_by_sex_for_owners",
            query: {
                owner_ids: ownerIds,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Strains By Usage For Owners
     * Get strains for filter depending on the selected owner
     *
     * Send result as JSON response to client (a list of dicts containing
     * the strains divided by active/inactive).
     *
     * :param owner_ids: ['__all_for_alias__'] to get strains of all aliases of the user's alias;
     * or ID(s) of scientist strains shall be fetched for ('__all_for_alias__' might be included);
     * or None to get strains of all the user's aliases.
     *
     * :param filter_name: Name of a filter for which the strains are retrieved;
     * can be 'animal' or 'pup'; if not specified, all strains will be fetched.
     *
     * :param pup_strains: If pup strains should be fetched instead of animal strains;
     * should only be True when `filter` is not specified.
     *
     * :param unused: Will be passed to strain.get_strains_for_filter to indicate if we also want unused strains.
     *
     * :param active_or_inactive: Should the response contain active or inactive or both strains.
     * @returns StrainNameDetailsWithGroup Successful Response
     * @throws ApiError
     */
    public static getStrainsByUsageForOwners(
        data: $OpenApiTs["/strains/strains_by_usage_for_owners"]["get"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/strains/strains_by_usage_for_owners"]["get"]["res"][200]> {
        const { ownerIds, filterName, pupStrains, unused, activeOrInactive } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/strains/strains_by_usage_for_owners",
            query: {
                owner_ids: ownerIds,
                filter_name: filterName,
                pup_strains: pupStrains,
                unused,
                active_or_inactive: activeOrInactive,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Strain Ids By Name
     * Get strain IDs from strain names with placeholders
     *
     * This is a post request, because the list of possible strain IDs
     * might be too long to be sent as a query parameter.
     *
     * :param strain_names: Strain names with placeholders.
     *
     * :param possible_strain_ids: All strain IDs that are possible for the
     * owner currently selected in the filter; the result will only IDs
     * that are included here; this is to not reveal strain information
     * that the user is not allowed to see.
     * @returns number Successful Response
     * @throws ApiError
     */
    public static getStrainIdsByName(
        data: $OpenApiTs["/strains/strain_ids_by_name"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/strains/strain_ids_by_name"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/strains/strain_ids_by_name",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class SystemService {
    /**
     * Get Version
     * Get the current PyRAT version.
     * @returns Version Successful Response
     * @throws ApiError
     */
    public static getVersion(): CancelablePromise<$OpenApiTs["/system/version"]["get"]["res"][200]> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/system/version",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Post Exception
     * Write an exception to the server.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static writeException(
        data: $OpenApiTs["/system/exception"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/system/exception"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/system/exception",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class SystemStatusService {
    /**
     * Create Status Record
     * Create status record.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static createSystemStatusRecord(): CancelablePromise<
        $OpenApiTs["/system_status/record"]["post"]["res"][200]
    > {
        return __request(OpenAPI, {
            method: "POST",
            url: "/system_status/record",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Save Status Administration Settings
     * Save status administration settings.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static saveSystemStatusSettings(
        data: $OpenApiTs["/system_status/settings"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/system_status/settings"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/system_status/settings",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class TanksService {
    /**
     * Is Position Occupied
     * Check if given positions of a tank are occupied.
     *
     * Returns the set of positions that are already occupied.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static isPositionOccupied(
        data: $OpenApiTs["/tanks/is_position_occupied"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/tanks/is_position_occupied"]["get"]["res"][200]> {
        const { rackId, status, tankPosition } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/tanks/is_position_occupied",
            query: {
                rack_id: rackId,
                status,
                tank_position: tankPosition,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Quickselect
     * @returns TankQuickselectActionsSeedResponse Successful Response
     * @throws ApiError
     */
    public static getQuickselectActionsSeed(
        data: $OpenApiTs["/tanks/quickselect:get_actions_seed"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/tanks/quickselect:get_actions_seed"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/tanks/quickselect:get_actions_seed",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Post Quickselect
     * @returns TankQuickselectActionsResponse Successful Response
     * @throws ApiError
     */
    public static executeQuickselectActions(
        data: $OpenApiTs["/tanks/quickselect:execute_actions"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/tanks/quickselect:execute_actions"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/tanks/quickselect:execute_actions",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Tank Details Endpoint
     * Get tank details.
     * @returns TankDetails Successful Response
     * @throws ApiError
     */
    public static getTankDetails(
        data: $OpenApiTs["/tanks/{tank_id}/details"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/tanks/{tank_id}/details"]["get"]["res"][200]> {
        const { tankId, withNeighbors } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/tanks/{tank_id}/details",
            path: {
                tank_id: tankId,
            },
            query: {
                with_neighbors: withNeighbors,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Age Levels Endpoint
     * Get age levels.
     * @returns NameLabelProperty Successful Response
     * @throws ApiError
     */
    public static getAgeLevels(): CancelablePromise<$OpenApiTs["/tanks/age_levels"]["get"]["res"][200]> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/tanks/age_levels",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Age Level Endpoint
     * Update tank age level.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateAgeLevel(
        data: $OpenApiTs["/tanks/{tank_id}/update_age_level"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/tanks/{tank_id}/update_age_level"]["put"]["res"][200]> {
        const { tankId, ageLevel } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/tanks/{tank_id}/update_age_level",
            path: {
                tank_id: tankId,
            },
            query: {
                age_level: ageLevel,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Tank Medical Condition Dialog Seed Endpoint
     * Get details for the tank SetMedicalConditions-Dialog.
     * @returns TankMedicalConditionDialogSeed Successful Response
     * @throws ApiError
     */
    public static getTankMedicalConditionDialogSeed(
        data: $OpenApiTs["/tanks/{tank_id}/medical_condition_dialog"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/tanks/{tank_id}/medical_condition_dialog"]["get"]["res"][200]> {
        const { tankId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/tanks/{tank_id}/medical_condition_dialog",
            path: {
                tank_id: tankId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Tank Medical Conditions Endpoint
     * Set medical conditions for a tank.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setTankMedicalConditions(
        data: $OpenApiTs["/tanks/{tank_id}/medical_conditions"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/tanks/{tank_id}/medical_conditions"]["put"]["res"][200]> {
        const { tankId, requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/tanks/{tank_id}/medical_conditions",
            path: {
                tank_id: tankId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Crossing Detail Data Endpoint
     * Get crossing detail data.
     * @returns CrossingDetailData Successful Response
     * @throws ApiError
     */
    public static getCrossingDetailData(
        data: $OpenApiTs["/tanks/crossings/{crossing_id}/details"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/tanks/crossings/{crossing_id}/details"]["get"]["res"][200]> {
        const { crossingId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/tanks/crossings/{crossing_id}/details",
            path: {
                crossing_id: crossingId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete Crossing Endpoint
     * Delete crossing.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deleteCrossing(
        data: $OpenApiTs["/tanks/crossings/{crossing_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/tanks/crossings/{crossing_id}"]["delete"]["res"][200]> {
        const { crossingId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/tanks/crossings/{crossing_id}",
            path: {
                crossing_id: crossingId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Discard Crossing Endpoint
     * Discard crossing.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static discardCrossing(
        data: $OpenApiTs["/tanks/crossings/{crossing_id}:discarded"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/tanks/crossings/{crossing_id}:discarded"]["put"]["res"][200]> {
        const { crossingId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/tanks/crossings/{crossing_id}:discarded",
            path: {
                crossing_id: crossingId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Keep Crossing Endpoint
     * Keep crossing.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static keepCrossing(
        data: $OpenApiTs["/tanks/crossings/{crossing_id}:discarded"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/tanks/crossings/{crossing_id}:discarded"]["delete"]["res"][200]> {
        const { crossingId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/tanks/crossings/{crossing_id}:discarded",
            path: {
                crossing_id: crossingId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Repeat Crossing Endpoint
     * Repeat crossing.
     *
     * Returns the id of the new crossing.
     * @returns number Successful Response
     * @throws ApiError
     */
    public static repeatCrossing(
        data: $OpenApiTs["/tanks/crossings/{crossing_id}:repeat"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/tanks/crossings/{crossing_id}:repeat"]["post"]["res"][200]> {
        const { crossingId } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/tanks/crossings/{crossing_id}:repeat",
            path: {
                crossing_id: crossingId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Crossing Endpoint
     * Update crossing.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateCrossing(
        data: $OpenApiTs["/tanks/crossings/{crossing_id}:update"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/tanks/crossings/{crossing_id}:update"]["put"]["res"][200]> {
        const {
            crossingId,
            crossingTanks,
            responsibleId,
            strainId,
            classificationId,
            raisedTanks,
            recordDate,
            description,
            action,
        } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/tanks/crossings/{crossing_id}:update",
            path: {
                crossing_id: crossingId,
            },
            query: {
                crossing_tanks: crossingTanks,
                responsible_id: responsibleId,
                strain_id: strainId,
                classification_id: classificationId,
                raised_tanks: raisedTanks,
                record_date: recordDate,
                description,
                action,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Print Crossing Label Endpoint
     * Print crossing label.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static printCrossingLabel(
        data: $OpenApiTs["/tanks/crossings/{crossing_id}/print_label"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/tanks/crossings/{crossing_id}/print_label"]["put"]["res"][200]> {
        const { crossingId, offset, printer } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/tanks/crossings/{crossing_id}/print_label",
            path: {
                crossing_id: crossingId,
            },
            query: {
                offset,
                printer,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Label Endpoint
     * Get tank label.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getTankLabel(
        data: $OpenApiTs["/tanks/{tank_id}/get_label"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/tanks/{tank_id}/get_label"]["get"]["res"][200]> {
        const { tankId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/tanks/{tank_id}/get_label",
            path: {
                tank_id: tankId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Label Endpoint
     * Update tank label.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateTankLabel(
        data: $OpenApiTs["/tanks/{tank_id}/update_label"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/tanks/{tank_id}/update_label"]["put"]["res"][200]> {
        const { tankId, label } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/tanks/{tank_id}/update_label",
            path: {
                tank_id: tankId,
            },
            query: {
                label,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Tank Import Dialog Data Endpoint
     * Get tank import dialog data.
     * @returns TankImportDialogData Successful Response
     * @throws ApiError
     */
    public static getTankImportDialogData(
        data: $OpenApiTs["/tanks/get_tank_import_dialog_data"]["get"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/tanks/get_tank_import_dialog_data"]["get"]["res"][200]> {
        const { crossingId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/tanks/get_tank_import_dialog_data",
            query: {
                crossing_id: crossingId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Import Tanks Endpoint
     * Import tanks.
     *
     * Returns list of imported tank ids (added to database).
     * @returns number Successful Response
     * @throws ApiError
     */
    public static importTanks(
        data: $OpenApiTs["/tanks/import_tanks"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/tanks/import_tanks"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/tanks/import_tanks",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class CompetencesService {
    /**
     * Get Available Procedures
     * @returns CompetenceAvailableProcedure Successful Response
     * @throws ApiError
     */
    public static getAvailableProcedures(): CancelablePromise<
        $OpenApiTs["/competences/available_procedures"]["get"]["res"][200]
    > {
        return __request(OpenAPI, {
            method: "GET",
            url: "/competences/available_procedures",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Available Species
     * @returns CompetenceAvailableSpecies Successful Response
     * @throws ApiError
     */
    public static getAvailableSpecies(): CancelablePromise<
        $OpenApiTs["/competences/available_species"]["get"]["res"][200]
    > {
        return __request(OpenAPI, {
            method: "GET",
            url: "/competences/available_species",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Available Users
     * @returns CompetenceAvailableUser Successful Response
     * @throws ApiError
     */
    public static getAvailableUsers(): CancelablePromise<
        $OpenApiTs["/competences/available_users"]["get"]["res"][200]
    > {
        return __request(OpenAPI, {
            method: "GET",
            url: "/competences/available_users",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Competence Detail
     * @returns CompetenceDetails Successful Response
     * @throws ApiError
     */
    public static getCompetenceDetails(
        data: $OpenApiTs["/competences/competence/{competence_id}"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/competences/competence/{competence_id}"]["get"]["res"][200]> {
        const { competenceId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/competences/competence/{competence_id}",
            path: {
                competence_id: competenceId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Competence
     * @returns number Successful Response
     * @throws ApiError
     */
    public static updateCompetence(
        data: $OpenApiTs["/competences/competence/{competence_id}"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/competences/competence/{competence_id}"]["put"]["res"][200]> {
        const { competenceId, requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/competences/competence/{competence_id}",
            path: {
                competence_id: competenceId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete Competence
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deleteCompetence(
        data: $OpenApiTs["/competences/competence/{competence_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/competences/competence/{competence_id}"]["delete"]["res"][200]> {
        const { competenceId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/competences/competence/{competence_id}",
            path: {
                competence_id: competenceId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Create Competence
     * @returns number Successful Response
     * @throws ApiError
     */
    public static createCompetence(
        data: $OpenApiTs["/competences/competence"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/competences/competence"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/competences/competence",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Put Competent User
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateCompetentUserAssignment(
        data: $OpenApiTs["/competences/assignment/{assignment_id}"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/competences/assignment/{assignment_id}"]["put"]["res"][200]> {
        const { assignmentId, requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/competences/assignment/{assignment_id}",
            path: {
                assignment_id: assignmentId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class UserCertificatesService {
    /**
     * Update User Certificate Types Endpoint
     * Update the user_certificate categories.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateUserCertificateTypes(
        data: $OpenApiTs["/user_certificates/user_certificate_types"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/user_certificates/user_certificate_types"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/user_certificates/user_certificate_types",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get New User Certificate Endpoint
     * Get a new user certificate dialog seed.
     * @returns NewUserCertificateDialogSeed Successful Response
     * @throws ApiError
     */
    public static getNewUserCertificateDialogSeed(
        data: $OpenApiTs["/user_certificates/certificate/new"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/user_certificates/certificate/new"]["get"]["res"][200]> {
        const { userId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/user_certificates/certificate/new",
            query: {
                user_id: userId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Existing User Certificate Endpoint
     * Get an existing user certificate event dialog seed.
     * @returns ExistingUserCertificateDialogSeed Successful Response
     * @throws ApiError
     */
    public static getExistingUserCertificateDialogSeed(
        data: $OpenApiTs["/user_certificates/certificate/{user_certificate_id}"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/user_certificates/certificate/{user_certificate_id}"]["get"]["res"][200]> {
        const { userCertificateId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/user_certificates/certificate/{user_certificate_id}",
            path: {
                user_certificate_id: userCertificateId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update User Certificate Endpoint
     * Update a user certificate.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateUserCertificate(
        data: $OpenApiTs["/user_certificates/certificate/{user_certificate_id}"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/user_certificates/certificate/{user_certificate_id}"]["put"]["res"][200]> {
        const { userCertificateId, requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/user_certificates/certificate/{user_certificate_id}",
            path: {
                user_certificate_id: userCertificateId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Add User Certificate Endpoint
     * Add a user certificate.
     * @returns number Successful Response
     * @throws ApiError
     */
    public static addUserCertificate(
        data: $OpenApiTs["/user_certificates/certificate"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/user_certificates/certificate"]["post"]["res"][200]> {
        const { userId, requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/user_certificates/certificate",
            query: {
                user_id: userId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class UsersService {
    /**
     * Get Active Owner List
     * Get a list of active owners.
     * @returns BasicUser Successful Response
     * @throws ApiError
     */
    public static getActiveOwners(): CancelablePromise<$OpenApiTs["/users/active_owners"]["get"]["res"][200]> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/users/active_owners",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Responsible User List
     * Get a list of active owners.
     * @returns BasicUser Successful Response
     * @throws ApiError
     */
    public static getResponsibles(
        data: $OpenApiTs["/users/responsibles"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/users/responsibles"]["get"]["res"][200]> {
        const { userId, status } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/users/responsibles",
            query: {
                user_id: userId,
                status,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Prefixes
     * Get a list of prefixes for a user.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getPrefixes(
        data: $OpenApiTs["/users/prefixes"]["get"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/users/prefixes"]["get"]["res"][200]> {
        const { userId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/users/prefixes",
            query: {
                user_id: userId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get User List For Setting
     * Get a list of users for setting.
     * @returns BasicUser Successful Response
     * @throws ApiError
     */
    public static getUsersForSetting(
        data: $OpenApiTs["/users/for_setting"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/users/for_setting"]["get"]["res"][200]> {
        const { level, status } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/users/for_setting",
            query: {
                level,
                status,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Owners For Group Widget
     * Return a list of owners for a group widget.
     * @returns OwnersForGroupWidget Successful Response
     * @throws ApiError
     */
    public static getOwnersForGroupWidget(
        data: $OpenApiTs["/users/owners_for_group_widget"]["get"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/users/owners_for_group_widget"]["get"]["res"][200]> {
        const { groupIds, status } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/users/owners_for_group_widget",
            query: {
                group_ids: groupIds,
                status,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get User Status Endpoint
     * Get user status.
     * @returns UserStatusResponse Successful Response
     * @throws ApiError
     */
    public static getUserStatus(
        data: $OpenApiTs["/users/{user_id}/status"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/users/{user_id}/status"]["get"]["res"][200]> {
        const { userId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/users/{user_id}/status",
            path: {
                user_id: userId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set User Status Endpoint
     * Set user status.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setUserStatus(
        data: $OpenApiTs["/users/{user_id}/status"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/users/{user_id}/status"]["put"]["res"][200]> {
        const { userId, status } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/users/{user_id}/status",
            path: {
                user_id: userId,
            },
            query: {
                status,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Add Color Rule Endpoint
     * Add a color rule.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static addColorRule(
        data: $OpenApiTs["/users/color_rules"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/users/color_rules"]["post"]["res"][200]> {
        const { entity, color, criterionField, criterionValue } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/users/color_rules",
            query: {
                entity,
                color,
                criterion_field: criterionField,
                criterion_value: criterionValue,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Color Rule Endpoint
     * Update a color rule.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateColorRule(
        data: $OpenApiTs["/users/color_rules/{color_rule_id}"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/users/color_rules/{color_rule_id}"]["put"]["res"][200]> {
        const { colorRuleId, color } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/users/color_rules/{color_rule_id}",
            path: {
                color_rule_id: colorRuleId,
            },
            query: {
                color,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete Color Rule Endpoint
     * Delete a color rule.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deleteColorRule(
        data: $OpenApiTs["/users/color_rules/{color_rule_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/users/color_rules/{color_rule_id}"]["delete"]["res"][200]> {
        const { colorRuleId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/users/color_rules/{color_rule_id}",
            path: {
                color_rule_id: colorRuleId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Totp Secret Endpoint
     * Get the totp secret for a user.
     * @returns TotpSecretResponse Successful Response
     * @throws ApiError
     */
    public static getTotpSecret(
        data: $OpenApiTs["/users/totp_secret/{user_id}"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/users/totp_secret/{user_id}"]["get"]["res"][200]> {
        const { userId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/users/totp_secret/{user_id}",
            path: {
                user_id: userId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Post Totp Secret Endpoint
     * Set the totp secret for a user.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setTotpSecret(
        data: $OpenApiTs["/users/totp_secret/{user_id}"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/users/totp_secret/{user_id}"]["post"]["res"][200]> {
        const { userId, requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/users/totp_secret/{user_id}",
            path: {
                user_id: userId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete Totp Secret Endpoint
     * Delete the totp secret for a user.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static removeTotpSecret(
        data: $OpenApiTs["/users/totp_secret/{user_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/users/totp_secret/{user_id}"]["delete"]["res"][200]> {
        const { userId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/users/totp_secret/{user_id}",
            path: {
                user_id: userId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Webauthn Endpoint
     * Get webauthn registration options.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getWebAuthnRegistrationOptions(): CancelablePromise<
        $OpenApiTs["/users/webauthn"]["get"]["res"][200]
    > {
        return __request(OpenAPI, {
            method: "GET",
            url: "/users/webauthn",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Post Webauthn Endpoint
     * Register a webauthn device.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static registerWebAuthnDevice(
        data: $OpenApiTs["/users/webauthn"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/users/webauthn"]["post"]["res"][200]> {
        const { deviceName, requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/users/webauthn",
            query: {
                device_name: deviceName,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete Webauthn Device Endpoint
     * Delete a webauthn device.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static removeWebAuthnDevice(
        data: $OpenApiTs["/users/webauthn/{device_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/users/webauthn/{device_id}"]["delete"]["res"][200]> {
        const { deviceId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/users/webauthn/{device_id}",
            path: {
                device_id: deviceId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Post Saml User Id
     * Set the SAML remote user id for a local user.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setSamlRemoteUserId(
        data: $OpenApiTs["/users/saml"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/users/saml"]["post"]["res"][200]> {
        const { localUserId, remoteUserId } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/users/saml",
            query: {
                local_user_id: localUserId,
                remote_user_id: remoteUserId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get New User Details Endpoint
     * Get user details seed for new users.
     * @returns BasicUserDetailsSeed Successful Response
     * @throws ApiError
     */
    public static getNewUserDetailsSeed(): CancelablePromise<$OpenApiTs["/users/users/new"]["get"]["res"][200]> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/users/users/new",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Existing User Details Endpoint
     * Get user details seed.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getExistingUserDetailsSeed(
        data: $OpenApiTs["/users/users/{user_id}"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/users/users/{user_id}"]["get"]["res"][200]> {
        const { userId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/users/users/{user_id}",
            path: {
                user_id: userId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class WellplatesService {
    /**
     * Get Wellplate Export Seed Endpoint
     * Get the seed for exporting wellplates.
     * @returns WellplateExportSeed Successful Response
     * @throws ApiError
     */
    public static getWellplatesExportSeed(): CancelablePromise<
        $OpenApiTs["/wellplates/export_seed"]["get"]["res"][200]
    > {
        return __request(OpenAPI, {
            method: "GET",
            url: "/wellplates/export_seed",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Dialog Options Endpoint
     * Get the options for the wellplate picker.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getWellplatesDialogSeed(
        data: $OpenApiTs["/wellplates/dialog_seed"]["get"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/wellplates/dialog_seed"]["get"]["res"][200]> {
        const { wellplateId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/wellplates/dialog_seed",
            query: {
                wellplate_id: wellplateId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Add Wellplate Endpoint
     * Add a wellplate.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static addWellplate(
        data: $OpenApiTs["/wellplates/"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/wellplates/"]["post"]["res"][200]> {
        const { formatId, code, reference, responsibleId, fillDirection, mode } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/wellplates/",
            query: {
                format_id: formatId,
                code,
                reference,
                responsible_id: responsibleId,
                fill_direction: fillDirection,
                mode,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Wellplate Endpoint
     * Update a wellplate.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateWellplate(
        data: $OpenApiTs["/wellplates/{wellplate_id}"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/wellplates/{wellplate_id}"]["put"]["res"][200]> {
        const { wellplateId, formatId, code, reference, responsibleId, fillDirection, mode } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/wellplates/{wellplate_id}",
            path: {
                wellplate_id: wellplateId,
            },
            query: {
                format_id: formatId,
                code,
                reference,
                responsible_id: responsibleId,
                fill_direction: fillDirection,
                mode,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Delete Wellplate Endpoint
     * Delete a wellplate.
     *
     * Requirements for deletion:
     * - wellplate exists (for given wellplate_id) and
     * - wellplate has no related animals/pups and
     * - wellplate status is "active" or "ready"
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deleteWellplate(
        data: $OpenApiTs["/wellplates/{wellplate_id}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/wellplates/{wellplate_id}"]["delete"]["res"][200]> {
        const { wellplateId } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/wellplates/{wellplate_id}",
            path: {
                wellplate_id: wellplateId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Update Used Wellplate Endpoint
     * Update a wellplate that has some animals assigned.
     *
     * In that case not all the fields can be modified.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static updateUsedWellplate(
        data: $OpenApiTs["/wellplates/{wellplate_id}/used"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/wellplates/{wellplate_id}/used"]["put"]["res"][200]> {
        const { wellplateId, responsibleId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/wellplates/{wellplate_id}/used",
            path: {
                wellplate_id: wellplateId,
            },
            query: {
                responsible_id: responsibleId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Wellplate Ready Endpoint
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setWellplateReady(
        data: $OpenApiTs["/wellplates/{wellplate_id}:ready"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/wellplates/{wellplate_id}:ready"]["put"]["res"][200]> {
        const { wellplateId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/wellplates/{wellplate_id}:ready",
            path: {
                wellplate_id: wellplateId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Wellplate Exported Endpoint
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setWellplateExported(
        data: $OpenApiTs["/wellplates/{wellplate_id}:exported"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/wellplates/{wellplate_id}:exported"]["put"]["res"][200]> {
        const { wellplateId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/wellplates/{wellplate_id}:exported",
            path: {
                wellplate_id: wellplateId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Wellplate Active Endpoint
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static reopenWellplate(
        data: $OpenApiTs["/wellplates/{wellplate_id}:open"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/wellplates/{wellplate_id}:open"]["put"]["res"][200]> {
        const { wellplateId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/wellplates/{wellplate_id}:open",
            path: {
                wellplate_id: wellplateId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Wellplate Closed Endpoint
     * Close a wellplate.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setWellplateClosed(
        data: $OpenApiTs["/wellplates/{wellplate_id}:closed"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/wellplates/{wellplate_id}:closed"]["put"]["res"][200]> {
        const { wellplateId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/wellplates/{wellplate_id}:closed",
            path: {
                wellplate_id: wellplateId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Invalidate Wellplate Position Endpoint
     * Invalidate a wellplate position.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static invalidateWellplatePosition(
        data: $OpenApiTs["/wellplates/{wellplate_id}/{wellplate_position}"]["delete"]["req"],
    ): CancelablePromise<$OpenApiTs["/wellplates/{wellplate_id}/{wellplate_position}"]["delete"]["res"][200]> {
        const { wellplateId, wellplatePosition } = data;
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/wellplates/{wellplate_id}/{wellplate_position}",
            path: {
                wellplate_id: wellplateId,
                wellplate_position: wellplatePosition,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Picker Options Endpoint
     * Get the options for the wellplate picker.
     * @returns MicroWellPlatePickerOptions Successful Response
     * @throws ApiError
     */
    public static getWellplatePickerOptions(
        data: $OpenApiTs["/wellplates/{wellplate_id}/picker_options"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/wellplates/{wellplate_id}/picker_options"]["post"]["res"][200]> {
        const { wellplateId, requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/wellplates/{wellplate_id}/picker_options",
            path: {
                wellplate_id: wellplateId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }
}

export class WorkRequestsService {
    /**
     * Validate Global Work Request Selection
     * Validate animals/pups/cages in global selection for work request
     *
     * Return a warning and error messages for animals/pups and for cages, if necessary.
     * @returns GlobalSelectionValidationResult Successful Response
     * @throws ApiError
     */
    public static validateGlobalWorkRequestSelection(
        data: $OpenApiTs["/work_requests/validate_global_select"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/validate_global_select"]["get"]["res"][200]> {
        const { incidentClassId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/work_requests/validate_global_select",
            query: {
                incident_class_id: incidentClassId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Work Request Additional Fields
     * Get the additional input fields for a work request class.
     * @returns WorkRequestAdditionalField Successful Response
     * @throws ApiError
     */
    public static getWorkRequestAdditionalFields(
        data: $OpenApiTs["/work_requests/additional_fields"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/additional_fields"]["get"]["res"][200]> {
        const { classId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/work_requests/additional_fields",
            query: {
                class_id: classId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get New Work Request Dialog Seed Endpoint
     * Get dialog seed for the new work request dialog.
     *
     * :param preselect_wr_class_id: Optional. The work request class to be preselected in the new work request.
     *
     * :param require_wr_behavior: Optional. The work request behavior to be shown in the new work request.
     * Defaults to all work request behaviors.
     * @returns NewWorkRequestDialogSeed Successful Response
     * @throws ApiError
     */
    public static getNewWorkRequestDialogSeed(
        data: $OpenApiTs["/work_requests/new/seed"]["post"]["req"] = {},
    ): CancelablePromise<$OpenApiTs["/work_requests/new/seed"]["post"]["res"][200]> {
        const { preselectWrClassId, requireWrBehavior, requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/work_requests/new/seed",
            query: {
                preselect_wr_class_id: preselectWrClassId,
                require_wr_behavior: requireWrBehavior,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Create Work Request Endpoint
     * Create a new work request.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static createWorkRequest(
        data: $OpenApiTs["/work_requests/"]["post"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/"]["post"]["res"][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, {
            method: "POST",
            url: "/work_requests/",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Work Request Details Endpoint
     * Get dialog seed for work request details
     * @returns WorkRequestDetailsSeed Successful Response
     * @throws ApiError
     */
    public static getWorkRequestDetails(
        data: $OpenApiTs["/work_requests/details"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/details"]["get"]["res"][200]> {
        const { workRequestId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/work_requests/details",
            query: {
                work_request_id: workRequestId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Work Request Due Date Endpoint
     * Set the due date for a work request.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setWorkRequestDueDate(
        data: $OpenApiTs["/work_requests/{work_request_id}/due_date"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/{work_request_id}/due_date"]["put"]["res"][200]> {
        const { workRequestId, dueDate } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/work_requests/{work_request_id}/due_date",
            path: {
                work_request_id: workRequestId,
            },
            query: {
                due_date: dueDate,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Work Request Approved Endpoint
     * Set the work request as approved.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setWorkRequestApproved(
        data: $OpenApiTs["/work_requests/{work_request_id}/approve"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/{work_request_id}/approve"]["put"]["res"][200]> {
        const { workRequestId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/work_requests/{work_request_id}/approve",
            path: {
                work_request_id: workRequestId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Work Request Rejected Endpoint
     * Set the work request as rejected.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setWorkRequestRejected(
        data: $OpenApiTs["/work_requests/{work_request_id}/reject"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/{work_request_id}/reject"]["put"]["res"][200]> {
        const { workRequestId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/work_requests/{work_request_id}/reject",
            path: {
                work_request_id: workRequestId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Perform Work Request Move Cage Endpoint
     * Perform a work request with 'move_cage' behavior.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static performWorkRequestMoveCage(
        data: $OpenApiTs["/work_requests/{work_request_id}/perform_move_cage"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/{work_request_id}/perform_move_cage"]["put"]["res"][200]> {
        const { workRequestId, closeRequest, cageIds, confirmedSanitaryStatus } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/work_requests/{work_request_id}/perform_move_cage",
            path: {
                work_request_id: workRequestId,
            },
            query: {
                close_request: closeRequest,
                cage_ids: cageIds,
                confirmed_sanitary_status: confirmedSanitaryStatus,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Add Work Request Comment Endpoint
     * Add a comment for a work request.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static addWorkRequestComment(
        data: $OpenApiTs["/work_requests/{work_request_id}/comment"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/{work_request_id}/comment"]["put"]["res"][200]> {
        const { workRequestId, comment } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/work_requests/{work_request_id}/comment",
            path: {
                work_request_id: workRequestId,
            },
            query: {
                comment,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Work Request Additional Fields Endpoint
     * Save the additional fields for a work request.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setWorkRequestAdditionalFields(
        data: $OpenApiTs["/work_requests/{work_request_id}/additional_fields"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/{work_request_id}/additional_fields"]["put"]["res"][200]> {
        const { workRequestId, requestBody } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/work_requests/{work_request_id}/additional_fields",
            path: {
                work_request_id: workRequestId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Work Request Class Dialog Seed Endpoint
     * Get details for the work request SetClass-Dialog.
     * @returns WorkRequestClassDialogSeed Successful Response
     * @throws ApiError
     */
    public static getWorkRequestClassDialogSeed(
        data: $OpenApiTs["/work_requests/{work_request_id}/class_dialog"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/{work_request_id}/class_dialog"]["get"]["res"][200]> {
        const { workRequestId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/work_requests/{work_request_id}/class_dialog",
            path: {
                work_request_id: workRequestId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Work Request Class Endpoint
     * Set the class for a work request.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setWorkRequestClass(
        data: $OpenApiTs["/work_requests/{work_request_id}/class"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/{work_request_id}/class"]["put"]["res"][200]> {
        const { workRequestId, classId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/work_requests/{work_request_id}/class",
            path: {
                work_request_id: workRequestId,
            },
            query: {
                class_id: classId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Work Request Location Dialog Seed Endpoint
     * Get details for the work request SetLocation-Dialog.
     * @returns WorkRequestLocationDialogSeed Successful Response
     * @throws ApiError
     */
    public static getWorkRequestLocationDialogSeed(
        data: $OpenApiTs["/work_requests/{work_request_id}/location_dialog"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/{work_request_id}/location_dialog"]["get"]["res"][200]> {
        const { workRequestId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/work_requests/{work_request_id}/location_dialog",
            path: {
                work_request_id: workRequestId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Work Request Location Endpoint
     * Set the location for a work request.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setWorkRequestLocation(
        data: $OpenApiTs["/work_requests/{work_request_id}/location"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/{work_request_id}/location"]["put"]["res"][200]> {
        const { workRequestId, wrBuildingId, wrAreaId, wrRoomId, wrRackId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/work_requests/{work_request_id}/location",
            path: {
                work_request_id: workRequestId,
            },
            query: {
                wr_building_id: wrBuildingId,
                wr_area_id: wrAreaId,
                wr_room_id: wrRoomId,
                wr_rack_id: wrRackId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Work Request Priority Dialog Seed Endpoint
     * Get details for the work request SetPriority-Dialog.
     * @returns WorkRequestPriorityDialogSeed Successful Response
     * @throws ApiError
     */
    public static getWorkRequestPriorityDialogSeed(
        data: $OpenApiTs["/work_requests/{work_request_id}/priority_dialog"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/{work_request_id}/priority_dialog"]["get"]["res"][200]> {
        const { workRequestId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/work_requests/{work_request_id}/priority_dialog",
            path: {
                work_request_id: workRequestId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Work Request Priority Endpoint
     * Set the priority for a work request.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setWorkRequestPriority(
        data: $OpenApiTs["/work_requests/{work_request_id}/priority"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/{work_request_id}/priority"]["put"]["res"][200]> {
        const { workRequestId, priorityId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/work_requests/{work_request_id}/priority",
            path: {
                work_request_id: workRequestId,
            },
            query: {
                priority_id: priorityId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Work Request Project
     * Get assigned project id from work request
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getWorkRequestProject(
        data: $OpenApiTs["/work_requests/{request_id}/project"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/{request_id}/project"]["get"]["res"][200]> {
        const { requestId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/work_requests/{request_id}/project",
            path: {
                request_id: requestId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Work Request Project
     * Set project id for work request
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setWorkRequestProject(
        data: $OpenApiTs["/work_requests/{request_id}/project"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/{request_id}/project"]["put"]["res"][200]> {
        const { requestId, projectId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/work_requests/{request_id}/project",
            path: {
                request_id: requestId,
            },
            query: {
                project_id: projectId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Work Request Responsible Dialog Seed Endpoint
     * Get details for the work request SetResponsible-Dialog.
     * @returns WorkRequestResponsibleDialogSeed Successful Response
     * @throws ApiError
     */
    public static getWorkRequestResponsibleDialogSeed(
        data: $OpenApiTs["/work_requests/{work_request_id}/responsible_dialog"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/{work_request_id}/responsible_dialog"]["get"]["res"][200]> {
        const { workRequestId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/work_requests/{work_request_id}/responsible_dialog",
            path: {
                work_request_id: workRequestId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Work Request Responsible Endpoint
     * Set the responsible for a work request.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setWorkRequestResponsible(
        data: $OpenApiTs["/work_requests/{work_request_id}/responsible"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/{work_request_id}/responsible"]["put"]["res"][200]> {
        const { workRequestId, responsibleId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/work_requests/{work_request_id}/responsible",
            path: {
                work_request_id: workRequestId,
            },
            query: {
                responsible_id: responsibleId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Work Request Status Dialog Seed Endpoint
     * Get details for the work request SetStatus-Dialog.
     * @returns WorkRequestStatusDialogSeed Successful Response
     * @throws ApiError
     */
    public static getWorkRequestStatusDialogSeed(
        data: $OpenApiTs["/work_requests/{work_request_id}/status_dialog"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/{work_request_id}/status_dialog"]["get"]["res"][200]> {
        const { workRequestId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/work_requests/{work_request_id}/status_dialog",
            path: {
                work_request_id: workRequestId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Set Work Request Status Endpoint
     * Set the status for a work request.
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static setWorkRequestStatus(
        data: $OpenApiTs["/work_requests/{work_request_id}/status"]["put"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/{work_request_id}/status"]["put"]["res"][200]> {
        const { workRequestId, statusId } = data;
        return __request(OpenAPI, {
            method: "PUT",
            url: "/work_requests/{work_request_id}/status",
            path: {
                work_request_id: workRequestId,
            },
            query: {
                status_id: statusId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }

    /**
     * Get Work Request Class Planned Procedures
     * Get the planned procedures for a work request class.
     * @returns WorkRequestClassPlannedProcedures Successful Response
     * @throws ApiError
     */
    public static getWorkRequestClassPlannedProcedures(
        data: $OpenApiTs["/work_requests/work_request_class/planned_procedures"]["get"]["req"],
    ): CancelablePromise<$OpenApiTs["/work_requests/work_request_class/planned_procedures"]["get"]["res"][200]> {
        const { workRequestClassId } = data;
        return __request(OpenAPI, {
            method: "GET",
            url: "/work_requests/work_request_class/planned_procedures",
            query: {
                work_request_class_id: workRequestClassId,
            },
            errors: {
                422: "Validation Error",
            },
        });
    }
}
